const etLocale = {
    common: {
        Save: "Salvesta",
        Send: "Saada",
        Cancel: "Tühista",
        Delete: "Kustuta",
        Remove: "Eemalda",
        Add: "Lisa",
        Restore: "Taasta",
        Retry: "Proovi uuesti",
        Search: "Otsi",
        Reset: "Lähtesta",
        Contract: "Leping",
        AddGuardian: "Lisa lähedane",
        Filter: "Filter",
        ApplyFilter: "Rakenda filter",
        ClearFilters: "Tühjenda filtrid",
        From: "Alates",
        To: "Kuni",
        Detail: "Detail",
        Objects: "Objektid",
        Actions: "Tegevused",
        SelectOption: "Valige variant",
        SearchByName: "Otsi nime või isikukoodi järgi",
        SearchByNameOrCode: "Otsi nime või koodi järgi",
        SearchByNameAndCode: "Otsi nime ja koodi järgi",
        SearchByCode: "Otsi koodi järgi",
        BookingSystem: "Broneerimissüsteem",
        PageNotFound: "Lehte ei leitud",
        PageNotFoundDescription: "Otsitavat lehte ei eksisteeri.",
        BackToDashboard: "Tagasi avalehele",
        SearchByType: "Filtreeri tüübi järgi",
        SearchBySex: "Filtreeri soo järgi",
        SearchByResidentType: "Filtreeri elaniku tüübi järgi",
        SearchByMunicipality: "Filtreeri omavalitsuse järgi",
        SearchByDocumentType: "Filtreeri dokumendi tüübi järgi",
        SearchByNotes: "Otsi märkuste järgi",
        SearchByDescription: "Otsi kirjelduse järgi",
        SearchByMenu: "Otsi menüü sisu järgi",
        People: "inimest",
        FilterByStatus: "Filtreeri staatuse järgi",
        FilterByActive: "Filtreeri aktiivsuse järgi",
        FilterByType: "Filtreeri tüübi järgi",
        FilterByUnitType: "Filtreeri ühiku tüübi järgi",
        FilterByPackageType: "Filtreeri pakendi tüübi järgi",
        FilterByManufacturer: "Filtreeri tootja järgi",
        FilterByMunicipality: "Filtreeri omavalitsuse järgi",
        FilterByContractType: "Filtreeri lepingu tüübi järgi",
        FilterByLevel: "Filtreeri taseme järgi",
        FilterByResident: "Filtreeri elaniku järgi",
        SearchByContractId: "Otsi lepingu ID järgi",
        SelectContractType: "Vali lepingu tüüp",
        EnterContractId: "Sisesta lepingu ID",
        SelectResidentOrGuardian: "Vali elanik või lähedane",
        ResidentOrGuardianRequired: "Palun vali elanik või lähedane",
        SelectDocument: "Vali dokument",
        ComingSoon: "Varsti tulekul",
        EnterVersion: "Sisesta versioon",
        EnterComments: "Sisesta kommentaarid",
        FirstName: "Eesnimi",
        LastName: "Perekonnanimi",
        Phone: "Telefon",
        PhoneNumber: "Telefoninumber",
        Email: "E-post",
        FirstNameRequired: "Eesnimi on kohustuslik",
        LastNameRequired: "Perekonnanimi on kohustuslik",
        PhoneRequired: "Telefoninumber on kohustuslik",
        EmailRequired: "E-posti aadress on kohustuslik",
        InvalidEmail: "Palun sisesta korrektne e-posti aadress",
        StartDateRequired: "Alguskuupäev on kohustuslik",
        EndDateOptional: "Lõppkuupäev on valikuline",
        EndDateRequired: "Lõppkuupäev on kohustuslik",
        DateRangeRequired: "Kuupäevavahemik on kohustuslik",
        ContractTypeRequired: "Lepingu tüüp on kohustuslik",
        CalculationSetupRequired: "Arvutuse seadistus on kohustuslik",
        DocumentRequired: "Dokument on kohustuslik",
        Reason: "Põhjus",
        OptionalField: "Valikuline väli",
        ReadOnlyField: "See väli on ainult lugemiseks",
        Sunday: "Pühapäev",
        Monday: "Esmaspäev",
        Tuesday: "Teisipäev",
        Wednesday: "Kolmapäev",
        Thursday: "Neljapäev",
        Friday: "Reede",
        Saturday: "Laupäev",
        MunicipalityNameRequired: "Omavalitsuse nimi on kohustuslik",
        MunicipalityCodeRequired: "Omavalitsuse kood on kohustuslik",
        MunicipalitySupportRequired: "Omavalitsuse piirmäär/toetus on kohustuslik",
        MonthlyPaymentRequired: "Igakuine makse on kohustuslik",
        Setup: "Seadistus",
        SelectCalculationSetup: "Vali arvutuse seadistus",
        ManageCalculationSetups: "Halda arvutuse seadistusi",
        MunicipalityName: "Omavalitsuse nimi",
        MunicipalityCode: "Omavalitsuse kood",
        ContractType: "Lepingu tüüp",
        SupportedFormats: "Toetatud vormingud",
        Documents: "Dokumendid",
        Document: "Dokument",
        StartDate: "Alguskuupäev",
        EndDate: "Lõppkuupäev",
        NoEndDate: "Lõppkuupäev puudub",
        All: "Kõik",
        Deleted: "Kustutatud",
        Searching: "Otsimine",
        RequiredFields: "Kohustuslikud väljad",
        TypeAtLeast3Characters: "Aadressi otsimiseks sisestage vähemalt 3 tähemärki",
        AddressNotFound: "Aadressi ei leitud",
        Forbidden: "Juurdepääs keelatud",
        InsufficientPrivileges: "Ebapiisavad õigused ligipääsuks",
        AdvancedSearch: "Täiustatud otsing",
        BasicSearch: "Lihtne otsing",
        ResetFilters: "Nulli filtrid",
        ToggleSelection: "Lülita valimine",
        SelectAll: "Vali kõik",
        ClearSelection: "Tühista valik",
        SelectedItems: "Valitud üksused",
        Active: "Aktiivne",
        Enabled: "Lubatud",
        Inactive: "Mitteaktiivne",
        Refresh: "Värskenda",
        Menu: "Menüü",
        Name: "Nimi",
        Edit: "Muuda",
        Code: "Kood",
        Description: "Kirjeldus",
        Notes: "Teenuse sisu",
        ServiceNotes: "Teenuse sisu",
        CreatedOn: "Loodud",
        ModifiedOn: "Muudetud",
        Translations: "Tõlked",
        Translate: "Tõlgi",
        ShowFilters: "Näita filtreid",
        HideFilters: "Peida filtrid",
        ErrorLoadingData: "Viga andmete laadimisel",
        LoadingError: "Viga andmete laadimisel",
        SaveError: "Viga andmete salvestamisel",
        DeleteError: "Viga andmete kustutamisel",
        RestoreError: "Viga andmete taastamisel",
        RequiredFieldsError: "Palun täitke järgmised kohustuslikud väljad: {fields}",
        ChangeType: "Muudatuse tüüp",
        Guardians: "Lähedased",
        ChangedFields: "Muudetud väljad",
        NoFieldsChanged: "Välju ei muudetud",
        NoDataFound: "Andmeid ei leitud",
        Success: "Edukas",
        Error: "Viga",
        SaveSuccess: "Edukalt salvestatud",
        CreateSuccess: "Edukalt loodud",
        UpdateSuccess: "Edukalt uuendatud",
        DeleteSuccess: "Edukalt kustutatud",
        RestoreSuccess: "Edukalt taastatud",
        ConfirmDeletion: "Kinnita kustutamine",
        Today: "Täna",
        Clear: "Tühista",
        Selected: "Valitud",
        Close: "Sulge",
        FailedToLoadData: "Andmete laadimine ebaõnnestus",
        History: "Ajalugu",
        User: "Kasutaja",
        Employee: "Töötaja",
        CreatedBy: "Looja",
        ModifiedBy: "Muutja",
        Period: "Periood",
        Type: "Tüüp",
        View: "Vaata",
        Resident: "Elanik",
        ResidentFilter: "Elanik",
        SearchForResident: "Otsi elanikku...",
        SearchResidents: "Otsi elanikke...",
        NoResidentsFound: "Elanikke ei leitud",
        DateRange: "Kuupäevavahemik",
        SelectDateRange: "Vali kuupäevavahemik",
        SelectDate: "Vali kuupäev",
        ListView: "Loendivaade",
        Upload: "Laadi üles",
        Create: "Loo",
        Facility: "Asutus",
        Date: "Kuupäev",
        Comments: "Kommentaarid",
        Note: "Märkus",
        Select: "Vali",
        Quantity: "Kogus",
        FromDate: "Alates kuupäevast",
        ToDate: "Kuni kuupäevani",
        FilterByArticle: "Filtreeri artikli järgi",
        Room: "Ruum",
        SelectRoom: "Vali ruum",
        waitlist: {
            Waitlist: "Ootenimekiri",
            SelectService: "Vali teenus",
            Priority: "Prioriteet",
            Status: "Staatus",
            SubscribeClient: "Lisa klient ootenimekirja",
            ClientId: "Kliendi ID",
            Notes: "Märkused",
            Subscribe: "Lisa",
            InvitesForSlot: "Kutsed ajale",
            Sent: "Saadetud",
            Expires: "Aegub",
            CreateInvite: "Loo kutse",
            WaitlistId: "Ootenimekirja ID",
            WindowMinutes: "Aken (minutid)",
            SendInvite: "Saada kutse",
            SubscriptionCreated: "Ootenimekirja tellimus loodud",
            EditSubscription: "Muuda ootenimekirja tellimust",
            InvalidBookingId: "Vigane broneeringu ID",
            InviteDataIncomplete: "Kutse andmed on puudulikud",
            InviteAccepted: "Kutse vastu võetud",
            InviteDeclined: "Kutse tagasi lükatud",
            PleaseProvideWaitlistAndBookingId: "Palun sisesta ootenimekirja ID ja broneeringu ID",
            InviteSent: "Kutse saadetud",
            BookingIdMissing: "Broneeringu ID puudub"
        },
        Template: {
            Language: "Keel",
            Value: "Väärtus"
        },
        UnsavedChanges: "Salvestamata muudatused",
        UnsavedChangesWarning: "Teil on salvestamata muudatused. Kas olete kindel, et soovite sulgeda ilma salvestamata?",
        CloseWithoutSaving: "Sulge ilma salvestamata",
        OpenInNewTab: "Ava uues vahekaardis",
        Optional: "Valikuline",
        AllMunicipalities: "Kõik omavalitsused",
        Municipality: "Omavalitsus",
        NotSet: "Seadistamata",
        SelectNone: "Ära vali midagi",
        SelectMunicipality: "Vali omavalitsus",
        MunicipalityRequired: "Omavalitsus on kohustuslik",
        MunicipalityLoadingError: "Viga omavalitsuste laadimisel",
        ContractDetails: "Lepingu üksikasjad",
        Status: "Staatus",
        Days: "Päevad",
        ExportToExcel: "Ekspordi Excelisse",
        Approve: "Kinnita",
        Approved: "Kinnitatud",
        Unapprove: "Tühista kinnitus",
        Go: "Mine",
        SelectAction: "Vali tegevus",
        SelectedCount: "{count} valitud",
        Adjust: "Kohanda",
        Balanced: "Tasakaalus",
        Unbalanced: "Tasakaalust väljas",
        Manual: "Käsitsi sisestus",
        Calculated: "Arvutatud",
        Back: "Tagasi",
        AddTemplate: "Lisa mall",
        Generate: "Genereeri",
        GenerateDocument: "Genereeri dokument",
        GenerateFromTemplate: "Genereeri mallist",
        DocumentTemplate: "Dokumendi mall",
        DocumentTemplateInfo: "Vali dokumendi mall lepingute genereerimiseks",
        SelectTemplateToGenerate: "Vali mall uue dokumendi genereerimiseks",
        TemplateRequired: "Palun vali dokumendi mall",
        GenerateDocumentInfo: "Genereeri uus dokument valitud mallist lepingu andmetega",
        DocumentGeneratedSuccessfully: "Dokument genereeritud edukalt",
        DocumentGenerationError: "Dokumendi genereerimine ebaõnnestus",
        GenerateDocumentError: "Viga dokumendi genereerimisel",
        GenerateError: "Viga lepingu ja dokumendi genereerimisel",
        SelectDocumentTemplate: "Palun vali dokumendi mall esmalt",
        DecisionNumber: "Otsuse number",
        DecisionNumberRequired: "Otsuse number on kohustuslik",
        SelectMunicipalityContract: "Vali omavalitsuse otsus",
        MunicipalityContractRequired: "Omavalitsuse otsus on kohustuslik",
        SelectedContract: "Valitud leping",
        Previous: "Eelmine",
        Next: "Järgmine",
        SelectServiceCalculationSetup: "Vali teenuse arvutuse seadistus",
        ContractDocuments: "Lepingu dokumendid",
        IsActive: "On aktiivne",
        Yes: "Jah",
        No: "Ei",
        JustNow: "Äsja",
        MinutesAgo: "{minutes} minutit tagasi",
        HoursAgo: "{hours} tundi tagasi",
        ViewDetails: "Vaata üksikasju",
        Service: "Teenus",
        Client: "Klient",
        SelectClient: "Vali klient"
    },
    menu: {
        Dashboard: "Töölaud",
        Bookings: "Broneeringud",
        Waitlist: "Ootenimekiri",
        Clients: "Kliendid",
        Services: "Teenused",
        Employees: "Töötajad",
        Suggestions: "Soovitused",
        Notifications: "Teavitused",
        Reports: "Aruanded",
        Rooms: "Ruumid",
        Settings: "Seaded",
        Residents: "Elanikud",
        Documents: "Dokumendid",
        Observations: "Vaatlused",
        FoodMenu: "Toidumenüü",
        ScheduledActivity: "Planeeritud tegevus",
        Accounting: "Raamatupidamine",
        Stock: "Ladu",
        AddNew: "Lisa uus",
        SaveSuccess: "Salvestamine õnnestus",
    },
    report: {
        ClientServiceVisitsTitle: "Kliendi teenuskülastuste aruanne",
        ClientServiceHistoryTitle: "Kliendi teenuste ajalugu",
        BookingCancellationsTitle: "Broneeringu tühistamised",
        SelectServices: "Vali teenused",
        SelectClient: "Vali klient või laps",
        VisitDateRange: "Külastuse kuupäevavahemik",
        NoData: "Aruande andmeid ei leitud",
        ChildName: "Lapse nimi",
        ParticipantName: "Osaleja",
        VisitCount: "Külastuste arv",
        CancellationCount: "Tühistamiste arv",
        LastVisitDate: "Viimane külastus",
        BookingStartTime: "Teenuse algus",
        BookingEndTime: "Teenuse lopp",
        CancellationDate: "Kuupäev",
        CancellationTime: "Kellaaeg",
        CancellationReason: "Tühistamise põhjus",
        CancellationReasonMissing: "Põhjus puudub",
        Duration: "Kestus",
        ContractCode: "Lepingu kood",
        AccountingCode: "Raamatupidamise kood",
        TotalAmount: "Kogusumma",
        VisitAmount: "Ühe korra summa",
        BookingNotes: "Teenuse sisu",
        InternalComment: "Sisemine märkus",
        BookingEmployee: "Töötaja",
        ExportExcel: "Ekspordi Excelisse",
        OpenClientDetail: "Ava kliendi detail",
        OpenFullClientView: "Ava kliendi täisvaade",
        ClientNotFound: "Kliendi andmeid ei leitud",
        LoadFailed: "Aruande laadimine ebaõnnestus",
        LoadClientFailed: "Kliendi detaili laadimine ebaõnnestus",
        LoadServicesFailed: "Teenuste laadimine ebaõnnestus"
    },
    residents: {
        Resident: "Elanik",
        Residents: "Elanikud",
        ResidentsPlural: "elanikku",
        ResidentDetail: "Elaniku andmed",
        AddResident: "Lisa elanik",
        FirstName: "Eesnimi",
        LastName: "Perekonnanimi",
        IdentityCode: "Isikukood",
        ResidentType: "Elaniku tüüp",
        Sex: "Sugu",
        BirthDate: "Sünniaeg",
        Age: "Vanus",
        AgeCalculatedFromBirthDate: "Vanus arvutatakse automaatselt sünniajast",
        Address: "Aadress",
        Municipality: "Omavalitsus",
        PhoneNumber: "Telefoninumber",
        ResidentPhoneNumber: "Elaniku telefoninumber",
        Guardians: "Lähedased",
        GuardianFirstName: "Lähedase eesnimi",
        GuardianLastName: "Lähedase perekonnanimi",
        GuardianEmail: "Lähedase e-post",
        GuardianPhone: "Lähedase telefon",
        Relationship: "Suhe",
        ResidentHistory: "Elaniku ajalugu",
        ResidentHistoryDescription: "Vaata kõiki selle elaniku muudatusi",
        NoHistoryFound: "Selle elaniku kohta ajalugu ei leitud",
        ResidentContracts: "Lepingud",
    },
    residentContract: {
        Contracts: "Lepingud",
        ResidentContracts: "Lepingud",
        ContractNumber: "Lepingu number",
        FacilityContracts: "Asutuse lepingud",
        MunicipalityContracts: "Omavalitsuse otsused",
        FacilityContract: "Asutuse leping",
        MunicipalityContract: "Omavalitsuse otsus",
        ContractType: "Lepingu tüüp",
        StartDate: "Alguskuupäev",
        EndDate: "Lõppkuupäev",
        ContactPerson: "Kontaktisik",
        Phone: "Telefon",
        Email: "E-post",
        Municipality: "Omavalitsus",
        MunicipalitySupport: "Omavalitsuse piirmäär",
        Pension: "Pension",
        Allowance: "Taskuraha",
        IsLiablePersonAvailable: "Vastutav isik saadaval",
        ExtraFinanceSupport: "Lisa rahalistoetus",
        MunicipalityExtraFunding: "Omavalitsuse lisarahastus",
        SelectContract: "Vali leping",
        CurrentContract: "Kehtiv leping",
        NoContractsFound: "Lepinguid ei leitud",
        ServiceCalculationSetup: "Teenuse arvestuse seadistus",
        Document: "Dokument",
        Description: "Halda elaniku lepinguid, sealhulgas asutuse lepinguid ja omavalitsuse otsuseid",
        AddContract: "Lisa leping",
        EditContract: "Muuda lepingut",
        AddMunicipalityContract: "Lisa omavalitsuse otsus",
        EditMunicipalityContract: "Muuda omavalitsuse otsust",
        DetailDialogComingSoon: "Lepingu detailvorm implementeeritakse järgmises faasis",
        MunicipalityDetailDialogComingSoon: "Omavalitsuse otsuse detailvorm implementeeritakse järgmises faasis",
        CreateSuccess: "Leping loodud edukalt",
        UpdateSuccess: "Leping uuendatud edukalt",
        CreateResidentContract: "Loo elaniku leping",
        ChooseMunicipalityContract: "Vali omavalitsuse otsus",
        MunicipalityContractDescription: "Esmalt vali olemasolev omavalitsuse otsus või loo uus. Seda otsust kasutatakse elaniku lepingu alusena.",
        FillContractDetails: "Täida lepingu detailid",
        ContractDetailsDescription: "Nüüd täida selle elaniku lepingu konkreetsed detailid, sealhulgas elanik/lähedane, kuupäevad ja arvutuse seaded.",
        Step1ChooseMunicipalityContract: "Vali omavalitsuse otsus",
        Step2FillContractDetails: "Täida lepingu detailid",
        ConfirmRestoreContract: "Kas oled kindel, et soovid taastada lepingu {contractName} #{contractNumber}?",
        ContractRestored: "Leping edukalt taastatud",
        ResidentDeletedError: "Ei saa lepingut taastada: elanik on kustutatud. Palun taasta esmalt elanik.",
        // History
        ContractHistory: "Lepingu ajalugu",
        ViewHistory: "Vaata ajalugu",
        ChangeType: "Muutuse tüüp",
        ChangedFields: "Muudetud väljad"
    },
    residentContractBooking: {
        BookingPeriods: "Broneerimise perioodid",
        AddBooking: "Lisa broneeringu periood",
        EditBooking: "Muuda broneeringu perioodi",
        BookingPercentage: "Broneeringu protsent",
        BookingPercentageInfo: "Tavatasu protsent broneeringu perioodi eest (nt 70% reserveeritud/broneeritud perioodide puhul)",
        BookingPercentageRequired: "Broneeringu protsent on kohustuslik",
        ReasonPlaceholder: "Sisesta broneeringu perioodi põhjus (valikuline)",
        SaveSuccess: "Broneeringu periood salvestatud edukalt",
        OverlapWarning: "Tuvastati kuupäevavahemiku kattuvus",
        OverlapDetails: "See broneeringu periood kattub olemasoleva broneeringuga. Palun korrigeeri kuupäevi."
    },
    residentContractTimeOff: {
        TimeOffPeriods: "Vaba aja perioodid",
        AddTimeOff: "Lisa vaba aja periood",
        EditTimeOff: "Muuda vaba aja perioodi",
        DailyRate: "Päevamäär",
        DailyRateInfo: "Fikseeritud päevamäär vaba aja perioodi eest (nt 45€ päevas)",
        DailyRateRequired: "Päevamäär on kohustuslik",
        ReasonPlaceholder: "Sisesta vaba aja perioodi põhjus (valikuline)",
        SaveSuccess: "Vaba aja periood salvestatud edukalt",
        OverlapWarning: "Tuvastati kuupäevavahemiku kattuvus",
        OverlapDetails: "See vaba aja periood kattub olemasoleva vaba ajaga. Palun korrigeeri kuupäevi."
    },
    residentMunicipalityContract: {
        AddContract: "Lisa omavalitsuse otsus",
        EditContract: "Muuda omavalitsuse otsust",
        CreateSuccess: "Omavalitsuse otsus loodud edukalt",
        UpdateSuccess: "Omavalitsuse otsus uuendatud edukalt",
        MonthlyPayment: "Igakuine makse",
        ExtraFinanceSupport: "Lähedaste poolt saadav lisaraha",
        MunicipalityExtraFunding: "Omavalitsuse poolt saadav lisaraha kokku (see on otsuses kirjas) välja arvatud taskuraha",
        ResidentOtherResponsibilitiesCost: "Elaniku muud vastutused",
        MunicipalitySupport: "Omavalitsuse piirmäär/toetus",
        Pension: "Pension",
        Allowance: "Taskuraha",
        IsLiablePersonAvailable: "On vastutav isik saadaval",
        IsSpecialCalculation: "Erikalkulatsioon (omavalitsus)",
        IsSpecialCalculationHelp: "Kui märgitud, kasutatakse Exceli erikorra loogikat; AF/AG/AH arvutatakse vastavalt arveldamiseks",
        ServiceFeeForFacility: "Hoolduskulu (K)",
        ServiceFeeForFacilityHelp: "Igakuine hoolduskulu asutusele (Exceli veerg K)"
    },
    guardian: {
        Guardians: "Lähedased",
        FirstName: "Eesnimi",
        LastName: "Perekonnanimi",
        Phone: "Telefon",
        Email: "E-post",
        Address: "Aadress",
        IdentityCode: "Isikukood",
        Relationship: "Suhe",
        IsSendReport: "Saada aruanne",
        AddGuardian: "Lisa lähedane",
        EditGuardian: "Muuda lähedast",
        DeleteGuardian: "Kustuta lähedane",
        FirstNamePlaceholder: "Sisesta eesnimi",
        LastNamePlaceholder: "Sisesta perekonnanimi",
        PhonePlaceholder: "Sisesta telefoninumber",
        EmailPlaceholder: "Sisesta e-posti aadress",
        AddressPlaceholder: "Sisesta aadress",
        IdentityCodePlaceholder: "Sisesta isikukood",
        SelectRelationship: "Vali suhe",
        FirstNameRequired: "Eesnimi on kohustuslik",
        LastNameRequired: "Perekonnanimi on kohustuslik",
        RelationshipRequired: "Suhe on kohustuslik",
        DeleteConfirmation: "Kas oled kindel, et soovid kustutada lähedase {name}?",
        SaveSuccess: "Lähedane salvestatud edukalt",
        DeleteSuccess: "Lähedane kustutatud edukalt",
    },
    settings: {
        General: "Üldine",
        Users: "Kasutajad",
        Roles: "Rollid",
        Lookups: "Klassifikaatorid",
        Qualifications: "Kvalifikatsioonid",
        Services: "Teenused",
        ServicesManagement: "Teenuste haldamine",
        UserManagement: "Kasutajate haldamine",
        RoleManagement: "Rollide haldamine",
        Municipalities: "Omavalitsused",
        LookupTypeName: "Klassifikaatori tüübi nimi",
        UserDetail: "Kasutaja andmed",
        Username: "Kasutajanimi",
        Password: "Salasõna",
        Email: "E-post",
        FirstName: "Eesnimi",
        LastName: "Perekonnanimi",
        RoleName: "Rolli nimi",
        FacilityName: "Asutuse nimi",
        Settings: "Seaded",
        PublicHolidays: "Riigipühad",
        AddPublicHoliday: "Lisa riigipüha",
        EditPublicHoliday: "Muuda riigipüha",
        HolidayDate: "Kuupäev",
        HolidayName: "Riigipüha",
        IsDayOff: "Vaba päev",
        SearchPublicHoliday: "Otsi kuupäeva või nime järgi",
        PublicHolidayHelp: "Kui riigipüha on märgitud vabaks päevaks, kuvatakse see kalendris punasena ja töötajate saadavus peidetakse.",
        PublicHolidayCreated: "Riigipüha lisati edukalt",
        PublicHolidayUpdated: "Riigipüha uuendati edukalt",
        PublicHolidayDeleted: "Riigipüha kustutati edukalt",
        PublicHolidayLoadFailed: "Riigipühade laadimine ebaõnnestus",
        PublicHolidaySaveFailed: "Riigipüha salvestamine ebaõnnestus",
        User: {
            ColorFieldTooltip: "Valige värv selle kasutaja tuvastamiseks süsteemis",
            UserRoles: "Kasutaja rollid",
            UserFacilities: "Kasutaja asutused",
        }
    },
    roles: {
        RoleCode: "Rolli kood",
        RoleName: "Rolli nimi",
        RoleDetail: "Rolli detailid",
        Privileges: "Õigused",
        PrivilegeName: "Õiguse nimi"
    },
    breadcrumb: {
        Home: "Avaleht",
        Dashboard: "Töölaud",
        Residents: "Elanikud",
        ResidentDetail: "Elaniku detailid",
        AddResident: "Lisa elanik",
        Services: "Teenused",
        Bookings: "Broneeringud",
        Waitlist: "Ooteleht",
        Qualifications: "Kvalifikatsioonid",
        Employees: "Töötajad",
        EmployeeDetail: "Töötaja andmed",
        CreateEmployee: "Loo töötaja",
        Clients: "Kliendid",
        ClientDetail: "Kliendi andmed",
        NewClient: "Uus klient",
        Rooms: "Ruumid",
        Settings: "Seaded",
        Documents: "Dokumendid",
        Stock: "Ladu",
        Articles: "Artiklid",
        ArticleDetail: "Artikli detailid",
        AddArticle: "Lisa artikkel",
        UserDetail: "Kasutaja detailid",
        AddUser: "Lisa kasutaja",
        Lookups: "Klassifikaatorid",
        LookupDetail: "Klassifikaatori detailid",
        AddLookup: "Lisa klassifikaator",
        Observations: "Vaatlused",
        ObservationDetail: "Vaatluse detailid",
        AddObservation: "Lisa vaatlus",
        FoodMenu: "Toidumenüü",
        EditFoodMenu: "Muuda toidumenüüd",
        AddFoodMenu: "Lisa toidumenüü",
        ScheduledActivities: "Planeeritud tegevused",
        ScheduledActivityDetail: "Planeeritud tegevuse detailid",
        AddScheduledActivity: "Lisa planeeritud tegevus",
        Invoices: "Arved",
        AddInvoice: "Lisa arve",
        InvoiceDetail: "Arve detailid",
        CalculationDetail: "Kalkulatsiooni detailid",
        StockLevels: "Lao tasemed",
        AddLevel: "Lisa tase",
        LevelDetail: "Lao taseme detailid",
        StockItems: "Lao esemed",
        AddItem: "Lisa ese",
        ItemDetail: "Eseme detailid",
        StockMovements: "Lao liikumised",
        AddMovement: "Lisa liikumine",
        Security: "Turvalisus",
        ActiveSessions: "Aktiivsed seansid",
        MyProfile: "Minu profiil",
        MySchedule: "Minu töögraafik",
        MyAbsences: "Minu puudumised",
        MyBookings: "Minu broneeringud",
        MyPasses: "Minu paketid",
        ServicePasses: "Teenuste paketid",
        Suggestions: "Soovitused",
        MySuggestions: "Minu soovitused",
        Reports: "Aruanded",
        NotificationManagement: "Teadete haldamine"
    },
    authentication: {
        Login: "Logi sisse",
        Logout: "Logi välja",
        Username: "Kasutajanimi",
        Password: "Salasõna",
        Email: "E-post",
        ForgotPassword: "Unustasid salasõna?",
        ResetPassword: "Taasta salasõna",
        NewPassword: "Uus salasõna",
        ConfirmPassword: "Kinnita salasõna",
        LoginError: "Vale kasutajanimi või salasõna.",
        SessionExpired: "Teie seanss on aegunud. Palun logige uuesti sisse.",
        LoginSuccess: "Sisse logimine õnnestus!",
        LogoutSuccess: "Välja logimine õnnestus!",
        ChangePasswordSuccess: "Salasõna on edukalt muudetud!",
        ForgotPasswordInstruction: "Sisestage oma e-posti aadress ja saadame teile salasõna taastamise lingi.",
        EnterEmail: "Sisestage oma e-posti aadress",
        SendResetLink: "Saada taastamise link",
        ResetEmailSent: "Kui selle e-postiga konto eksisteerib, on salasõna taastamise link saadetud.",
        CheckYourEmail: "Palun kontrollige oma e-posti taastamisjuhiste saamiseks",
        DidNotReceiveEmail: "Kui te ei näe e-kirja, kontrollige rämpsposti kausta või taotlege uus link.",
        ResendEmail: "Saada uuesti",
        ErrorSendingResetEmail: "Taastamise e-posti saatmine ebaõnnestus. Palun proovige uuesti.",
        ResetEmailError: "Taastamise e-posti saatmine ebaõnnestus. Palun proovige uuesti.",
        ResetPasswordInstruction: "Sisestage allpool oma uus salasõna.",
        EnterNewPassword: "Sisestage uus salasõna",
        EnterConfirmPassword: "Kinnitage uus salasõna",
        ConfirmNewPassword: "Kinnitage uus salasõna",
        PasswordsDoNotMatch: "Salasõnad ei ühti",
        PasswordResetSuccess: "Salasõna on edukalt taastatud! Suuname teid sisselogimislehele...",
        PasswordResetSuccessful: "Salasõna on edukalt taastatud!",
        PasswordResetError: "Salasõna taastamine ebaõnnestus. Palun proovige uuesti.",
        ErrorResettingPassword: "Salasõna taastamine ebaõnnestus. Palun proovige uuesti.",
        InvalidResetToken: "Kehtetu taastamise link",
        InvalidOrExpiredToken: "See taastamise link on kehtetu või aegunud",
        RequestNewResetLink: "Palun taotlege uus salasõna taastamine",
        RequestNewLink: "Taotlege uus taastamise link",
        InvalidResetTokenMessage: "See taastamise link on kehtetu või aegunud. Palun taotlege uus salasõna taastamine.",
        BackToLogin: "Tagasi sisselogimislehele",
        ValidatingToken: "Taastamise lingi valideerimine...",
        TokenExpired: "See taastamise link on aegunud. Palun taotlege uus.",
        TokenAlreadyUsed: "See taastamise link on juba kasutatud",
        PasswordRequirementsNotMet: "Salasõna ei vasta nõuetele"
    },
    profile: {
        ViewProfile: "Vaata profiili",
        EditProfile: "Muuda profiili",
        MyProfile: "Minu profiil",
        ChangePassword: "Muuda salasõna",
        MySchedule: "Minu töögraafik",
        MyAbsences: "Minu puudumised",
        MyBookings: "Minu broneeringud",
        Username: "Kasutajanimi",
        Email: "E-post",
        Phone: "Telefon",
        FirstName: "Eesnimi",
        LastName: "Perekonnanimi",
        CurrentPassword: "Praegune salasõna",
        NewPassword: "Uus salasõna",
        ConfirmPassword: "Kinnita salasõna",
        PasswordHint: "Vähemalt 8 märki"
    },
    auth: {
        Username: "Kasutajanimi",
        UsernameOrEmail: "Kasutajanimi või e-post",
        EnterUsernameOrEmail: "Sisesta oma kasutajanimi või e-post",
        Password: "Parool",
        Login: "Logi sisse",
        Logout: "Logi välja",
        LoggedOut: "Olete välja logitud",
        EnterUsername: "Sisestage oma kasutajanimi",
        EnterPassword: "Sisestage oma parool",
        LoginFailed: "Sisselogimine ebaõnnestus",
        LoginSuccessful: "Sisselogimine õnnestus",
        BookingSystemLogin: "Broneerimissüsteemi sisselogimine",
        ContactAdminForAccess: "Juurdepääsu saamiseks võtke ühendust administraatoriga",
        InsufficientPrivileges: "Ebapiisavad õigused",
        SessionExpired: "Teie seanss on aegunud",
        Register: "Registreeru",
        CreateYourAccount: "Loo oma konto",
        Email: "E-post",
        EnterEmail: "Sisesta oma e-posti aadress",
        FirstName: "Eesnimi",
        LastName: "Perekonnanimi",
        PhoneNumber: "Telefoninumber (valikuline)",
        PreferredLanguage: "Eelistatud keel",
        SelectLanguage: "Vali keel",
        EnterFirstName: "Sisesta oma eesnimi",
        EnterLastName: "Sisesta oma perekonnanimi",
        EnterPhoneNumber: "Sisesta oma telefoninumber",
        RegisterButton: "Loo konto",
        PasswordRequirements: "Salasõna peab olema vähemalt 8 tähemärki koos suurtähe, väiketähe, numbri ja erimärgiga (!@#$%^&*)",
        AlreadyHaveAccount: "On juba konto olemas?",
        LoginHere: "Logi sisse siin",
        DontHaveAccount: "Pole veel kontot?",
        RegisterHere: "Registreeru siin",
        VerifyEmail: "Kinnita e-post",
        VerifyEmailDescription: "Sisesta oma e-postile saadetud kinnituskood",
        VerificationToken: "Kinnituskood",
        EnterVerificationToken: "Sisesta kinnituskood",
        TokenFromEmail: "Leia see kood oma e-postist",
        VerifyButton: "Kinnita konto",
        VerificationSuccessful: "E-post on edukalt kinnitatud! Saad nüüd sisse logida.",
        VerificationFailed: "E-posti kinnitamine ebaõnnestus",
        VerifyingEmail: "Kinnitame sinu e-posti...",
        GoToLogin: "Mine sisselogimislehele",
        DidntReceiveEmail: "Ei saanud e-posti kätte?",
        ResendVerification: "Saada kinnituskiri uuesti",
        VerificationEmailResent: "Kinnituskiri on uuesti saadetud. Palun kontrolli oma postkasti.",
        RegistrationSuccessMessage: "Registreerimine õnnestus! Palun kontrolli oma e-posti, et kinnitada oma konto.",
        RegistrationFailed: "Registreerimine ebaõnnestus. Palun proovi uuesti.",
        InvalidEmail: "Palun sisesta kehtiv e-posti aadress",
        InvalidPhoneNumber: "Palun sisesta kehtiv telefoninumber",
        PasswordTooShort: "Salasõna peab olema vähemalt 8 tähemärki",
        PasswordNeedsUppercase: "Salasõna peab sisaldama vähemalt ühte suurtähte",
        PasswordNeedsLowercase: "Salasõna peab sisaldama vähemalt ühte väiketähte",
        PasswordNeedsNumber: "Salasõna peab sisaldama vähemalt ühte numbrit",
        PasswordNeedsSpecialChar: "Salasõna peab sisaldama vähemalt ühte erimärki (!@#$%^&*)",
        FirstNameRequired: "Eesnimi on kohustuslik",
        LastNameRequired: "Perekonnanimi on kohustuslik",
        EmailRequired: "E-post on kohustuslik",
        EmailAndTokenRequired: "E-post ja kood on kohustuslikud",
        ResendFailed: "Kinnituskirja uuesti saatmine ebaõnnestus",
        Registration_InvalidEmail: "Palun sisesta kehtiv e-posti aadress",
        Registration_EmailAlreadyExists: "See e-posti aadress on juba kasutusel. Palun kasutage teist e-posti aadressi või proovige sisse logida.",
        Registration_PasswordRequired: "Salasõna on kohustuslik",
        Registration_PasswordTooShort: "Salasõna peab olema vähemalt 8 tähemärki",
        Registration_PasswordNeedsUppercase: "Salasõna peab sisaldama vähemalt ühte suurtähte",
        Registration_PasswordNeedsLowercase: "Salasõna peab sisaldama vähemalt ühte väiketähte",
        Registration_PasswordNeedsNumber: "Salasõna peab sisaldama vähemalt ühte numbrit",
        Registration_PasswordNeedsSpecialChar: "Salasõna peab sisaldama vähemalt ühte erimärki",
        Registration_SystemError: "Süsteemi viga. Palun proovi hiljem uuesti.",
        Registration_Successful: "Registreerimine õnnestus! Kontrolli oma e-posti kinnituse jaoks.",
        Verification_InvalidToken: "Kehtetu kinnituskood",
        Verification_TokenExpired: "Kinnituskood on aegunud. Palun taotle uus.",
        Verification_TokenAlreadyUsed: "See kinnituskood on juba kasutatud",
        Verification_UserNotFound: "Kasutajat ei leitud",
        Verification_SystemError: "Süsteemi viga. Palun proovi hiljem uuesti.",
        Verification_Successful: "E-post on edukalt kinnitatud!",
        Verification_AlreadyVerified: "E-post on juba kinnitatud",
        Verification_EmailResent: "Kinnituskiri on uuesti saadetud",
        TooManyAttempts: "Liiga palju registreerimiskatseid. Palun proovi hiljem uuesti.",
        ForgotPassword: "Unustasid salasõna?",
        ForgotPasswordInstruction: "Sisesta oma e-posti aadress ja me saadame sulle lingi salasõna lähtestamiseks.",
        BackToLogin: "Tagasi sisselogimislehele",
        SendResetLink: "Saada lähtestamislink"
    },
    deleteDialog: {
        Header: "Kinnita kustutamine",
        DeleteMessage: "Kas olete kindel, et soovite kustutada {objectName}?",
        Delete: "Kustuta",
        Cancel: "Tühista",
        DeletedSuccessfully: "{objectName} on edukalt kustutatud!"
    },
    toast: {
        UserCreated: "Kasutaja on edukalt loodud!",
        UserUpdated: "Kasutaja on edukalt uuendatud!",
        UserDeleted: "Kasutaja on edukalt kustutatud!",
        FailedToSaveUser: "Kasutaja salvestamine ebaõnnestus!",
        FailedToDeleteUser: "Kasutaja kustutamine ebaõnnestus!",
        FailedToLoadUsers: "Kasutajate laadimine ebaõnnestus!",
        RoleCreated: "Roll on edukalt loodud!",
        RoleUpdated: "Roll on edukalt uuendatud!",
        RoleDeleted: "Roll on edukalt kustutatud!",
        FailedToSaveRole: "Rolli salvestamine ebaõnnestus!",
        FailedToDeleteRole: "Rolli kustutamine ebaõnnestus!",
        FailedToLoadRoles: "Rollide laadimine ebaõnnestus!",
        FailedToLoadPrivileges: "Õiguste laadimine ebaõnnestus!",
        RoleCodeAndNameRequired: "Rolli kood ja nimi on kohustuslikud!"
    },
    lookup: {
        Name: "Nimi",
        Code: "Kood",
        Type: "Tüüp",
        LookupDetail: "Õhinäitaja detailid",
        AddLookup: "Lisa õhinäitaja",
        EditLookup: "Muuda õhinäitajat",
        LoadError: "Viga õhinäitajate laadimisel"
    },
    municipality: {
        Municipality: "Omavalitsus",
        MunicipalityDetail: "Omavalitsuse detailid",
        AddMunicipality: "Lisa omavalitsus",
        EditMunicipality: "Muuda omavalitsust",
        MunicipalityName: "Omavalitsuse nimi",
        MunicipalityCode: "Omavalitsuse kood",
        ParentMunicipality: "Ülem-omavalitsus",
        ShowMoveChildrenTo: "Liiguta alamomavalitsused teise omavalitsusse",
        DeleteMunicipality: "Kustuta omavalitsus",
        MoveTo: "Liiguta",
        ConfirmDelete: "Kas olete kindel, et soovite selle omavalitsuse kustutada?",
        CannotDeleteWithChildren: "Ei saa kustutada omavalitsust, millel on alamomavalitsused. Palun liigutage või kustutage alamomavalitsused enne.",
        MunicipalityCreated: "Omavalitsus edukalt loodud",
        MunicipalityUpdated: "Omavalitsus edukalt uuendatud",
        MunicipalityDeleted: "Omavalitsus edukalt kustutatud"
    },
    document: {
        DownloadHistory: "Allalaadimisajalugu",
        NoDownloadHistory: "Allalaadimisajalugu ei leitud",
        Documents: "Dokumendid",
        Templates: "Mallid",
        Document: "Dokument",
        Name: "Nimi",
        Code: "Kood",
        DocumentType: "Dokumendi tüüp",
        File: "Fail",
        Download: "Laadi alla",
        Upload: "Laadi üles",
        CreateDocument: "Lisa dokument",
        EditDocument: "Muuda dokumenti",
        CreateTemplate: "Lisa mall",
        EditTemplate: "Muuda malli",
        AddTemplate: "Lisa mall",
        DeleteDocument: "Kustuta dokument",
        ConfirmDelete: "Kas olete kindel, et soovite kustutada dokumendi \"{name}\"?",
        SelectDocumentType: "Valige dokumendi tüüp",
        TemplateDocumentTypeInfo: "Mallid on automaatselt määratud Mall dokumendi tüübiks",
        AvailablePlaceholders: "Saadaval Placeholderid",
        PlaceholderUsageInfo: "Kasutage neid placeholdereid oma mallifailides. Need asendatakse automaatselt tegelike väärtustega dokumentide genereerimisel.",
        // Placeholder descriptions
        PlaceholderFirstName: "Elaniku eesnimi",
        PlaceholderLastName: "Elaniku perekonnanimi",
        PlaceholderPersonalCode: "Isikukood",
        PlaceholderBirthDate: "Sünniaeg",
        PlaceholderContractNumber: "Lepingu number",
        PlaceholderContractStartDate: "Lepingu alguskuupäev",
        PlaceholderContractEndDate: "Lepingu lõppkuupäev",
        PlaceholderFacilityName: "Asutuse nimi",
        PlaceholderMunicipalityName: "Omavalitsuse nimi",
        PlaceholderMunicipalityDecisionNr: "Omavalitsuse otsuse number",
        PlaceholderGuardianName: "Lähedase nimi",
        PlaceholderGuardianPhone: "Lähedase telefoninumber",
        PlaceholderGuardianEmail: "Lähedase e-posti aadress",
        PlaceholderResidentAddress: "Elaniku aadress",
        PlaceholderServiceType: "Teenuse tüüp",
        PlaceholderMonthlyCost: "Kuu teenuse maksumus",
        PlaceholderCreatedDate: "Lepingu loomise kuupäev",
        PlaceholderCreatedBy: "Lepingu loonud",
        ChooseFile: "Vali fail",
        ReplaceFile: "Asenda fail",
        SelectedFile: "Valitud fail",
        CurrentFileInfo: "Praegune fail - klõpsake allalaadimiseks või kustutamiseks",
        DownloadFile: "Laadi fail alla",
        DeleteFile: "Kustuta fail",
        FileMarkedForDeletion: "Fail märgitud kustutamiseks. Laadige üles uus fail või see eemaldatakse salvestamisel.",
        LoadError: "Viga dokumendi laadimisel",
        SaveSuccess: "Dokument edukalt salvestatud",
        SaveError: "Viga dokumendi salvestamisel",
        DeleteSuccess: "Dokument edukalt kustutatud",
        DeleteError: "Viga dokumendi kustutamisel",
        DownloadStarted: "Allalaadimine algas",
        DownloadError: "Viga dokumendi allalaadimisel"
    },
    medicalInformation: {
        BasicInformation: "Põhiinfo",
        MedicalConditions: "Meditsiinilised seisundid",
        Mobility: "Liikuvus",
        MobilityDescription: "Liikuvuse kirjeldus",
        HealthStatusNotes: "Tervisliku seisundi märkmed",
        InfectiousDiseaseNotes: "Nakkushaiguste märkmed",
        IsSmoker: "Suitsetaja",
        IsAlcoholic: "Alkohoolik",
        IsDementia: "Dementsus",
        IsViolent: "Vägivaldne",
        IsDigestionProblem: "Seedehäire",
        IsDiabetes: "Diabeet",
        IsMentalDisorder: "Psüühikahäire",
        IsSpeechImpairment: "Kõnepuue",
        IsHearingImpairment: "Kuulmispuue",
        IsMRSA: "MRSA",
        IsDialysis: "Dialüüs",
        IsESBL: "ESBL",
        IsTuberculosis: "Tuberkuloos",
        SaveSuccess: "Meditsiiniline info edukalt salvestatud",
        LoadError: "Viga meditsiinilise info laadimisel",
        SaveError: "Viga meditsiinilise info salvestamisel"
    },
    observation: {
        Observations: "Vaatlused",
        Observation: "Vaatlus",
        ObservationType: "Vaatluse tüüp",
        ObservationId: "Vaatluse ID",
        Notes: "Märkmed",
        ObservationDetails: "Vaatluse detailid",
        AddObservation: "Lisa vaatlus",
        EditObservation: "Muuda vaatlust",
        SelectObservationType: "Vali vaatluse tüüp",
        SelectResident: "Vali elanik",
        NotesPlaceholder: "Sisesta vaatluse märkmed...",
        ObservationTypeRequired: "Vaatluse tüüp on kohustuslik",
        NotesRequired: "Märkmed on kohustuslikud",
        ResidentRequired: "Elaniku valik on kohustuslik",
        CreateSuccess: "Vaatlus edukalt loodud",
        UpdateSuccess: "Vaatlus edukalt uuendatud",
        SaveError: "Viga vaatluse salvestamisel",
        LoadError: "Viga vaatluse laadimisel",
        DeleteError: "Viga vaatluse kustutamisel",
        NoObservationsFound: "Vaatlusi ei leitud",
        AddFirstObservation: "Lisa esimene vaatlus",
        types: {
            General: "Üldine",
            Medical: "Meditsiiniline",
            Behavioral: "Käitumuslik",
            Care: "Hooldus"
        }
    },
    foodMenu: {
        FoodMenu: "Toidumenüü",
        FoodMenus: "Toidumenüüd",
        AddFoodMenu: "Lisa toidumenüü",
        EditFoodMenu: "Muuda toidumenüüd",
        FoodMenuDetails: "Toidumenüü üksikasjad",
        BasicInformation: "Põhiteave",
        MenuDetails: "Menüü üksikasjad",
        Menu: "Menüü",
        NutritionalInformation: "Toitumisalane teave",
        MenuDate: "Menüü kuupäev",
        MenuPlaceholder: "Sisesta selle kuupäeva menüü kirjed...",
        NutritionalInfoPlaceholder: "Sisesta toitumisalane teave (kalorid, allergeenid jne)...",
        SelectDateRangeToStart: "Menüüde loomise alustamiseks valige kuupäevavahemik",
        SelectDateRange: "Valige kuupäevavahemik",
        LoadError: "Toidumenüüde laadimine ebaõnnestus",
        SaveError: "Toidumenüü salvestamine ebaõnnestus",
        DeleteError: "Toidumenüü kustutamine ebaõnnestus",
        CreateSuccess: "Toidumenüü edukalt loodud",
        UpdateSuccess: "Toidumenüü edukalt uuendatud",
        DeleteSuccess: "Toidumenüü edukalt kustutatud",
        SelectResidents: "Valige elanikud",
        AllResidentsSelected: "Kõik elanikud valitud",
        NoFoodMenusFound: "Toidumenüüsid ei leitud",
        AddFirstFoodMenu: "Lisa esimene toidumenüü",
        MenuRequired: "Menüü on kohustuslik",
        MenuDateRequired: "Menüü kuupäev on kohustuslik",
        ResidentsRequired: "Vähemalt üks elanik peab olema valitud",
        StartDateRequired: "Alguskuupäev on kohustuslik",
        EndDateRequired: "Lõppkuupäev on kohustuslik",
        EndDateMustBeAfterStartDate: "Lõppkuupäev peab olema pärast alguskuupäeva",
        SelectAtLeastOneResident: "Palun valige vähemalt üks elanik",
        NoMenuDatesToSave: "Salvestamiseks pole menüü kuupäevi",
        AllMenusMustBeFilled: "Kõik menüü väljad peavad olema täidetud",
        DateRange: "Kuupäevavahemik",
        StartDate: "Alguskuupäev",
        EndDate: "Lõppkuupäev"
    },
    scheduledActivity: {
        ScheduledActivities: "Planeeritud tegevused",
        ScheduledActivity: "Planeeritud tegevus",
        ActivityType: "Tegevuse tüüp",
        Description: "Kirjeldus",
        When: "Millal",
        Resident: "Elanik",
        AddScheduledActivity: "Lisa planeeritud tegevus",
        EditScheduledActivity: "Muuda planeeritud tegevust",
        SelectActivityType: "Vali tegevuse tüüp",
        SelectResident: "Vali elanik",
        DescriptionPlaceholder: "Sisesta tegevuse kirjeldus...",
        ActivityTypeRequired: "Tegevuse tüüp on kohustuslik",
        DescriptionRequired: "Kirjeldus on kohustuslik",
        ResidentRequired: "Elaniku valik on kohustuslik",
        CreateSuccess: "Planeeritud tegevus loodud edukalt",
        UpdateSuccess: "Planeeritud tegevus uuendatud edukalt",
        SaveError: "Planeeritud tegevuse salvestamine ebaõnnestus",
        LoadError: "Planeeritud tegevuse laadimine ebaõnnestus",
        DeleteError: "Planeeritud tegevuse kustutamine ebaõnnestus",
        NoItemsFound: "Planeeritud tegevusi ei leitud",
        AddFirstItem: "Lisa esimene planeeritud tegevus"
    },
    invoice: {
        Invoices: "Arved",
        InvoiceDetail: "Arve üksikasjad",
        AddInvoice: "Lisa arve",
        EditInvoice: "Muuda arvet",
        InvoiceDetails: "Arve üksikasjad",
        SearchByNumber: "Otsi arve numbri järgi",
        number: "Arve number",
        numberPlaceholder: "Sisesta arve number",
        resident: "Elanik",
        selectResident: "Vali elanik",
        type: "Arve tüüp",
        selectType: "Vali arve tüüp",
        startDate: "Alguskuupäev",
        selectDate: "Vali kuupäev",
        dueDate: "Tähtaeg",
        selectDueDate: "Vali tähtaeg",
        amount: "Summa",
        amountPlaceholder: "Sisesta summa",
        vatIncluded: "KM sisaldub",
        vatIncludedLabel: "KM sisaldub summas",
        document: "Failid",
        uploadDocument: "Vali fail",
        viewDocument: "Vaata faili",
        InvoiceDocument: "Arve fail",
        NoDocumentSelected: "Faili pole valitud",
        Number: "Arve number",
        StartDate: "Alguskuupäev",
        DueDate: "Tähtaeg",
        InvoiceType: "Arve tüüp",
        Amount: "Summa",
        IsVATIncluded: "KM sisaldub",
        Document: "Dokument",
        CalculationSetup: "Arvutusseadistus",
        Setup: "Seadistus",
        SetupDescription: "Halda arvutuse seadistusi ja teenuse arvutuse seadistusi arvete arvutamiseks.",
        ServiceCalculationSetupDescription: "Konfigureeri teenustasusid, baastasusid ja arveperioode erinevate teenuste jaoks.",
        CalculationSetupDescription: "Konfigureeri Exceli konstandeid ja omavalitsuse toetuse määrasid arvete arvutamiseks.",
        ManageServiceCalculationSetups: "Halda Teenuse Arvutuse Seadistusi",
        ManageCalculationSetups: "Halda Arvutuse Seadistusi",
        Download: "Laadi alla",
        NumberRequired: "Arve number on kohustuslik",
        StartDateRequired: "Alguskuupäev on kohustuslik",
        DueDateRequired: "Tähtaeg on kohustuslik",
        InvoiceTypeRequired: "Arve tüüp on kohustuslik",
        AmountRequired: "Summa peab olema suurem kui 0",
        ResidentRequired: "Elanik on kohustuslik",
        DocumentRequired: "Dokument on kohustuslik",
        DueDateMustBeAfterStartDate: "Tähtaeg peab olema suurem või võrdne alguskuupäevaga",
        InvoiceCreated: "Arve edukalt loodud",
        InvoiceUpdated: "Arve edukalt uuendatud",
        SaveError: "Viga arve salvestamisel",
        LoadError: "Viga arve laadimisel",
        DeleteError: "Viga arve kustutamisel",
        DownloadError: "Viga arve allalaadimisel",
        DownloadNotImplemented: "Allalaadimise funktsioon pole veel rakendatud",
        CalculationSetupNotImplemented: "Arvutusseadistus pole veel rakendatud",
        UploadNotImplemented: "Üleslaadimise funktsioon pole veel rakendatud",
        NoInvoicesFound: "Arveid ei leitud",
        AddFirstInvoice: "Lisa esimene arve",
        SelectInvoiceType: "Vali arve tüüp"
    },
    invoiceCalculation: {
        CalculationDetail: "Arvutuse üksikasjad",
        CalculatedValues: "Arvutatud väärtused",
        StockCostBreakdown: "Laokulu jaotus",
        StockItemsUsed: "Arvutuses kasutatud laoartiklid",
        NoStockItems: "Selles arvutuses ei kasutatud laoartikleid",
        TotalStockCost: "Kogu laokulu",
        Article: "Artikkel",
        Units: "Ühikud",
        CostPerUnit: "Maksumus ühiku kohta",
        TotalCost: "Kogu maksumus",
        MovementDate: "Liikumise kuupäev",
        MovementType: "Liikumise tüüp",
        StockLevel: "Laotase",
        Calculations: "Arvutused",
        InvoiceCalculationWorkflow: "Arve Arvutamise Töövoog",
        WorkflowDescription: "Loo ja halda elanike hulgiarveid",
        Step1Setup: "Seadista Arvutusparameetrid",
        Step2Selection: "Vali Elanikud",
        Step3Calculation: "Arvuta & Vaata üle",
        Step4Actions: "Lõplikud Tegevused",
        Step1Description: "Seadista arvutusparameetrid ja vali seadistus",
        Step2Description: "Vali elanikud ja sisesta käsitsi andmed",
        Step3Description: "Vaata üle arvutustulemused ja kinnita",
        Step4Description: "Lõplikud tegevused ja töövoo lõpetamine",
        CalculationPeriod: "Arvutusperiood",
        SelectPeriod: "Vali arvutusperiood",
        CalculationSetup: "Arvutusseadistus",
        SelectSetup: "Vali arvutusseadistus",
        SetupRequiredFields: "Palun vali arvutusseadistus ja periood jätkamiseks",
        ProceedToSelection: "Jätka valikuga",
        ResidentsSelected: "Valitud elanikud: {count}",
        ProceedToCalculation: "Jätka arvutamisega",
        CalculatingInProgress: "Arvutamine pooleli",
        ProcessingCalculations: "Arvutuste töötlemine...",
        RecalculateAll: "Arvuta kõik ümber",
        ProceedToActions: "Jätka tegevustega",
        CalculationResults: "Arvutustulemused",
        CalculationResultsDescription: "Vaata üle ja kinnita arvutustulemused",
        TotalCalculations: "Arvutusi kokku: {count}",
        ApprovedCalculations: "Kinnitatud: {count}",
        TotalAmount: "Kogusumma: {amount}",
        TotalAmountSum: "Kogusumma: {amount}",
        SpecialCalculations: "Eriomavalitsus: {count}",
        AverageAmount: "Keskmine summa: {amount}",
        ApproveAllCalculations: "Kinnita kõik arvutused",
        GenerateInvoices: "Genereeri arved",
        ExportToExcel: "Ekspordi Excelisse",
        StartNewWorkflow: "Alusta uut töövooga",
        SelectResidents: "Vali elanikud arvutamiseks",
        SelectResidentsDescription: "Vali elanikud hulgiarvutamiseks",
        SelectByMunicipality: "Vali omavalitsuse järgi",
        ExcelCalculationBreakdown: "Arvutuste jaotus",
        AllColumnsEtoAR: "Kõik arvutusveerud",
        MaintenanceObligated: "Ülalpidamiskohustuslik",
        CalculationType: "Arvutuse tüüp",
        ServicePeriodStartDate: "Teenuse algus",
        ServicePeriodEndDate: "Teenuse lõpp",
        DaysOfMonth: "Päevad",
        NursingHomeCareComponent: "Hooldekodu hoolduskomponent",
        ServiceFeePerDay: "Hoolduskulu päevas",
        FinalExtraCost: "Lisakulud",
        MunicipalityLimit: "KOV piirmäär",
        ResidentBrutoIncome: "Brutosissetulek",
        ResidentAllowence: "Taskuraha",
        ResidentOtherResponsibilitiesCost: "Muud kulud",
        BookingDays: "Broneeringute päevad",
        TimeOffDays: "Puhkepäevad",
        AverageOldAgePension: "Keskmine vanaduspension",
        ResidentTotalInMonth: "Elaniku kogusumma kuus",
        ThirdPartyTotalInMonth: "Kolmandate isikute kogusumma kuus",
        MunicipalityTotalObligations: "Omavalitsuse kohustused kuus",
        ExcelE: "Ülalpidamiskohustuslik isik olemas",
        ExcelF: "Arvutuse tüüp",
        ExcelG: "Teenuse perioodi algus",
        ExcelH: "Teenuse perioodi lõpp",
        ExcelI: "Kuu päevad",
        ExcelJ: "Teenustasu kuus",
        ExcelK: "Hoolduskulu",
        ExcelL: "Lisakulu",
        ExcelN: "Omavalitsuse piirmäär/toetus",
        ExcelO: "Teenustasu (kui > toetus)",
        ExcelP: "Muu kulu",
        ExcelQ: "Elaniku sissetulek",
        ExcelS: "Elaniku brutosissetulek",
        ExcelT: "Elaniku taskuraha",
        ExcelU: "Elaniku muud kohustused",
        ExcelV: "Elaniku kulu enne tuge",
        ExcelW: "Elaniku taskuraha jääk",
        ExcelZ: "Vajalik lisaraha",
        ExcelAA: "Madala sissetuleku kompensatsioon",
        ExcelAB: "Maksimaalne ülalpidamiskulu (Tallinn)",
        ExcelAE: "Lisahüvitis ülalpeetavatele",
        ExcelAF: "Elaniku kogusumma kuus",
        ExcelAG: "Kolmanda isiku kogusumma kuus",
        ExcelAH: "Omavalitsuse kohustuste kokkuvõte",
        ExcelAQ: "Koguarve ilma taskurahata",
        ExcelAR: "Kontrolli veerg",
        Special: "Eriline",
        Standard: "Tavaline",
        ViewBreakdown: "Vaata jaotust",
        ResidentTotal: "Elaniku kokku",
        ThirdParty: "Kolmas osapool",
        Municipality: "Omavalitsus",
        TotalBill: "Koguarve",
        Recalculate: "Arvuta ümber",
        NoCalculationsYet: "Arvutusi pole veel",
        SelectResidentsToCalculate: "Vali elanikud arvutamise alustamiseks",
        LoadingSetupsError: "Viga arvutusseadistuste laadimisel",
        CalculationsCompleted: "Arvutused lõpetatud edukalt",
        CalculationsPartiallyCompleted: "Arvutused osaliselt lõpetatud",
        NoCalculationsCompleted: "Arvutusi pole lõpetatud",
        NoCalculationsToExport: "Eksportimiseks pole arvutusi",
        NoCalculationLoaded: "Arvutust pole laaditud",
        ExcelExportSuccess: "Arvutused eksporditud Excelisse edukalt",
        CalculationError: "Viga arvutamisel",
        RecalculationError: "Viga ümberarvutamisel",
        ApprovalSuccess: "Arvutused kinnitatud edukalt",
        UnapprovalSuccess: "Kinnitused tühistatud edukalt",
        ApprovalError: "Viga arvutuste kinnitamisel",
        InvoiceGenerationNotImplemented: "Arvete genereerimine pole veel rakendatud",
        ExcelExportNotImplemented: "Exceli eksport pole veel rakendatud",
        WorkflowReset: "Töövoog on lähtestatud",
        CalculationBreakdown: "Arvutuse jaotus",
        BreakdownIntro: "Detailne vaade, kuidas iga väli arvutati, peegeldades Exceli veerge.",
        ExtraCost: "Lisakulu",
        ServiceFeeForFacility: "Hoolduskulu (K)",
        CareCostHelp: "Perioodi hoolduskulu (Excel K). Tuleneb teenuse arvutuse seadistusest; vajadusel saab kohandada.",
        CareCostFromContract: "Hoolduskulu on konfigureeritud elaniku omavalitsuse otsuses",
        NotSet: "Seadistamata",
        PlaceFeeOverride: "Kohatasu kuus (J) ülekirjutus",
        PlaceFeeOverrideHelp: "Valikuline ülekirjutus kohatasule kuus (Excel J). Jäta tühjaks, et kasutada seadistusest tulevat väärtust.",
        OtherResponsibilities: "Muud kohustused",
        LessDaysComment: "Vähem päevade kommentaar",
        LessDaysCommentPlaceholder: "Sisesta kommentaar vähendatud päevade kohta...",
        GeneralComment: "Üldine kommentaar",
        GeneralCommentPlaceholder: "Sisesta üldine kommentaar...",
        ReadyForCalculation: "Valmis arvutamiseks",
        MissingRequiredData: "Puuduvad nõutud andmed",
        ValidationIssues: "Valideerimisprobleemid",
        NoResidentsSelected: "Elanikke pole valitud",
        IncompleteResidents: "{count} elanikul on mittetäielikud andmed",
        ResidentsProcessed: "Töödeldud elanikud",
        CalculatedValue: "Arvutatud",
        Calculated: "Arvutatud",
        EditExtraCost: "Muuda lisakulu",
        CalculatedStockCost: "Arvutatud laokulu",
        AutomaticStockCalculation: "Automaatselt arvutatud valitud perioodi laotegevetustest",
        ManualOverride: "Käsitsi ületöötamine",
        EnterManualOverride: "Sisesta käsitsi ületöötamise summa...",
        ManualOverrideDescription: "Jäta tühjaks arvutatud laokulu kasutamiseks",
        EffectiveValue: "Efektiivne väärtus",
        UsingManualOverride: "Kasutab käsitsi ületöötatud väärtust",
        UsingCalculatedValue: "Kasutab arvutatud laokulu",
        ClearOverride: "Eemalda ületöötamine",
        ExtraCostUpdated: "Lisakulu edukalt uuendatud",
        ExtraCostUpdateError: "Viga lisakulu uuendamisel",
        AdjustExtraCost: "Kohanda lisakulu",
        AdjustmentAmount: "Korrigeerimise summa",
        EnterAdjustmentAmount: "Sisesta korrigeerimise summa (positiivne või negatiivne)...",
        AdjustmentAmountHelp: "Positiivsed väärtused lisavad kulu, negatiivsed annavad allahindlust. Null või tühi eemaldab korrigeerimise.",
        AdjustmentNote: "Korrigeerimise märkus",
        EnterAdjustmentNote: "Sisesta korrigeerimise põhjus (nõutav)...",
        CalculatedCost: "Arvutatud laokulu",
        Adjustment: "Korrektsioon",
        FinalCost: "Lõplik lisakulu",
        AdjustmentSaved: "Korrektsioon edukalt salvestatud",
        AdjustmentSaveError: "Viga korrektsiooni salvestamisel",
        AdjustedBy: "Korrigeeritud kasutaja poolt",
        AdjustedAt: "Korrigeeritud",
        AdjustmentApplied: "Korrektsioon on arvutusele rakendatud",
        // New keys for Calculation List View
        CalculationHistory: "Arvutuste ajalugu",
        CreateNewCalculation: "Loo uus arvutus",
        ApprovedLocked: "Kinnitatud (lukustatud)",
        NotApproved: "Kinnitamata",
        Approved: "Kinnitatud",
        ViewCalculation: "Vaata arvutust",
        DeleteCalculation: "Kustuta arvutus",
        ConfirmDeleteCalculation: "Kas olete kindel, et soovite selle arvutuse kustutada?",
        DeleteCalculationSuccess: "Arvutus edukalt kustutatud",
        DeleteCalculationError: "Arvutuse kustutamine ebaõnnestus",
        // Stock Movement Conflict Detection
        StockMovementConflictDetected: "Konflikt teise arve arvutusega",
        ConflictWarning: "See arvutus kasutab laotehinguid, mis on juba määratud teisele kinnitatud arvutusele.",
        ConflictDescription: "{count} laotehing(ut) konfliktis kinnitatud arvutus(t)ega: {calculationIds}",
        ConflictDescriptionShort: "{count} laotehing(ut) konfliktis kinnitatud arvutus(t)ega",
        MustRecalculate: "Konfliktide lahendamiseks peate enne kinnitamist arvutuse uuesti arvutama.",
        ConflictedMovements: "Konfliktis olevad laotehingud",
        ConflictingCalculations: "Konfliktis olevad arvutused",
        RecalculateToResolve: "Lahendamiseks arvuta uuesti",
        CannotApproveWithConflicts: "Laotehingute konfliktidega arvutust ei saa kinnitada",
        RecalculateSuccess: "Arvutus edukalt ümber arvutatud",
        RecalculateFailed: "Arvutuse ümberarvutamine ebaõnnestus",
        ApproveSuccess: "Arvutus edukalt kinnitatud",
        ApproveFailed: "Arvutuse kinnitamine ebaõnnestus",
        UnapproveSuccess: "Arvutuse kinnitamine edukalt tühistatud",
        UnapproveFailed: "Arvutuse kinnitamise tühistamine ebaõnnestus",
        CalculationCreatedSuccess: "Arvutus edukalt loodud",
        Calculation: "Arvutus",
        PeriodStart: "Perioodi algus",
        PeriodEnd: "Perioodi lõpp",
        BulkRecalculate: "Arvuta ümber",
        BulkDelete: "Kustuta",
        BulkApprove: "Kinnita",
        BulkExport: "Ekspordi Excelisse",
        BulkRecalculateSuccess: "{count} arvutus(t) edukalt ümber arvutatud",
        BulkRecalculateFailed: "Arvutuste ümberarvutamine ebaõnnestus",
        BulkDeleteSuccess: "{count} arvutus(t) edukalt kustutatud",
        BulkDeleteFailed: "Arvutuste kustutamine ebaõnnestus",
        BulkDeleteConfirm: "Kas olete kindel, et soovite kustutada {count} arvutus(t)?",
        BulkDeleteApprovedWarning: "Kinnitatud arvutusi ei saa kustutada. {count} kinnitatud arvutus(t) jäetakse vahele.",
        BulkApproveSuccess: "{successCount} arvutus(t) edukalt kinnitatud",
        BulkApprovePartial: "{successCount} kinnitatud, {failedCount} ebaõnnestus konfliktide või muude vigade tõttu",
        BulkApprovePartialFail: "{success} kinnitatud, {failed} ebaõnnestus konfliktide või muude vigade tõttu",
        BulkApproveFailed: "Arvutuste kinnitamine ebaõnnestus",
        SomeApprovedSkipped: "Mõned kinnitatud arvutused jäeti vahele",
        SomeAlreadyApprovedSkipped: "Mõned arvutused on juba kinnitatud ja jäeti vahele",
        AllAlreadyApproved: "Kõik valitud arvutused on juba kinnitatud",
        BulkExportSuccess: "Exceli fail edukalt loodud",
        BulkExportFailed: "Exceli faili loomine ebaõnnestus",
        BulkExportNotImplemented: "Exceli ekspordi funktsioon pole veel rakendatud. See funktsioon nõuab Exceli genereerimise teegi installimist.",
        SelectedCalculations: "{count} arvutus(t) valitud",
        DuplicateSelectionWarning: "Duplikaatne arvutus sama elaniku ja perioodi jaoks",
        CannotApproveDuplicates: "Ei saa kinnitada: sama elaniku ja perioodi jaoks on valitud duplikaatsed arvutused",
        ApprovedCalculationWarning: "Kinnitatud arvutust ei saa ümber arvutada",
        CannotRecalculateApproved: "Ei saa ümber arvutada: kinnitatud arvutused on valitud",
        CannotDeleteApproved: "Ei saa kustutada: kinnitatud arvutused on valitud"
    },
    calculationSetup: {
        CalculationSetups: "Arvutusseadistused",
        ManageCalculationSetups: "Halda arvutusseadistusi",
        ManageSetups: "Halda seadistusi",
        CreateSetup: "Loo arvutusseadistus",
        EditSetup: "Muuda arvutusseadistust",
        BasicInformation: "Põhiinformatsioon",
        ExcelConstants: "Exceli konstandid (Exceli viidetest)",
        NamePlaceholder: "Sisesta seadistuse nimi (nt Suve 2024 hinnad)",
        DescriptionPlaceholder: "Sisesta kirjeldus (valikuline)",
        MunicipalitySupportPerResident: "Omavalitsuse piirmäär/toetus elaniku kohta",
        Support1: "Toetuse tase 1 ($I$7)",
        Support2: "Toetuse tase 2 ($I$8)",
        Support3: "Toetuse tase 3 ($I$9)",
        Preview: "Eelvaade",
        MunicipalitySupport: "Omavalitsuse piirmäär/toetus",
        Constants: "Konstandid",
        UsageCount: "Kasutamiste arv",
        Duplicate: "Dubleeeri",
        SearchByName: "Otsi arvutusseadistusi nime järgi",
        NameRequired: "Nimi on kohustuslik",
        ReportPeriodRequired: "Aruandeperioodi päevad on kohustuslikud",
        Support1Required: "Toetuse tase 1 on kohustuslik",
        Support2Required: "Toetuse tase 2 on kohustuslik",
        Support3Required: "Toetuse tase 3 on kohustuslik",
        CreatedSuccessfully: "Arvutusseadistus loodud edukalt",
        UpdatedSuccessfully: "Arvutusseadistus uuendatud edukalt",
        DuplicatedSuccessfully: "Arvutusseadistus dubleeritud edukalt",
        CreateError: "Viga arvutusseadistuse loomisel",
        UpdateError: "Viga arvutusseadistuse uuendamisel",
        DuplicationError: "Viga arvutusseadistuse dubleerimisel",
        DeleteError: "Viga arvutusseadistuse kustutamisel",
        LoadingError: "Viga arvutusseadistuste laadimisel",
        DuplicateSetup: "Dubleeri seadistus",
        DuplicateSetupDescription: "Loo selle seadistuse koopia uue nimega",
        DuplicateNameSuffix: "Koopia",
        DuplicateNamePlaceholder: "Sisesta uus nimi dubleeritud seadistusele",
        DuplicateNameRequired: "Dubleeritud nimi on kohustuslik"
    },
    serviceCalculationSetup: {
        ServiceCalculationSetups: "Teenuse Arvutuse Seadistused",
        ManageServiceCalculationSetups: "Halda Teenuse Arvutuse Seadistusi",
        CreateServiceCalculationSetup: "Loo Teenuse Arvutuse Seadistus",
        EditServiceCalculationSetup: "Muuda Teenuse Arvutuse Seadistust",
        BaseFee: "Baastasu",
        Period: "Periood",
        SelectPeriod: "Vali Periood",
        BookingPercentage: "Broneeringu protsent",
        TimeOffDailyRate: "Vaba aja päevamäär",
        SearchByName: "Otsi nime järgi",
        SearchByCode: "Otsi koodi järgi",
        NameRequired: "Nimi on kohustuslik",
        CodeRequired: "Kood on kohustuslik",
        BaseFeeRequired: "Baastasu on kohustuslik",
        PeriodRequired: "Periood on kohustuslik"
    },
    validation: {
        Required: "See väli on nõutav",
        InvalidEmail: "Sobimatu e-posti aadress",
        MinLength: "Minimaalne pikkus on {min} tähemärki",
        MaxLength: "Maksimaalne pikkus on {max} tähemärki"
    },
    residentContractDocument: {
        ContractDocuments: "Lepingu dokumendid",
        CreateContractDocument: "Loo lepingu dokument",
        EditContractDocument: "Muuda lepingu dokumenti",
        ContractType: "Lepingu tüüp",
        ContractId: "Lepingu ID",
        Document: "Dokument",
        DocumentType: "Dokumendi tüüp",
        IsActive: "On aktiivne",
        Version: "Versioon",
        SetActive: "Määra aktiivseks",
        DocumentSetActive: "Dokument on määratud aktiivseks"
    },
    stock: {
        Stock: "Ladu",
        Articles: "Artiklid",
        Article: "Artikkel",
        ArticleName: "Artikli nimetus",
        ArticleCode: "Artikli kood",
        ArticleType: "Artikli tüüp",
        EditArticle: "Muuda artiklit",
        Manufacturer: "Tootja",
        Unit: "Ühiku kogus",
        PackageType: "Pakendi tüüp",
        ActiveIngredient: "Toimeaine",
        Strength: "Tugevus",
        Description: "Kirjeldus",
        StandardCost: "Standardhind",
        RequiresPrescription: "Vajab retsepti",
        IsControlledSubstance: "On kontrollitav aine",
        StorageConditions: "Hoiutingimused",
        BasicInformation: "Põhiandmed",
        Inventory: "Laoseis",
        StockLevels: "Lao tasemed",
        StockLevel: "Lao tase",
        CreateLevel: "Loo tase",
        EditLevel: "Muuda taset",
        AddLevel: "Lisa tase",
        LevelDetail: "Taseme andmed",
        CreateStockLevel: "Loo laoseis",
        EditStockLevel: "Muuda laoseisu",
        NewStockLevel: "Uus laoseis",
        EnterLevelName: "Sisesta taseme nimetus",
        EnterLevelCode: "Sisesta taseme kood",
        EnterLevelDescription: "Sisesta taseme kirjeldus",
        Level: "Tase",
        Assignments: "Määramised",
        Items: "Esemed",
        StockItems: "Laoesemed",
        AddItem: "Lisa ese",
        AddStockItem: "Lisa laoese",
        EditStockItem: "Muuda laoeset",
        NoItemsInLevel: "Selles laoseisus pole esemeid",
        SearchByStockLevel: "Otsi lao taseme järgi",
        StockLevelFilter: "Lao taseme filter",
        NoStockLevelsFound: "Lao tasemeid ei leitud",
        AddFirstItem: "Klõpsa 'Lisa ese', et lisada esimene laoese",
        ViewStockLevel: "Vaata laoseisu",
        Movements: "Liikumised",
        StockMovements: "Lao liikumised",
        AddMovement: "Lisa liikumine",
        MovementType: "Liikumise tüüp",
        StockItem: "Laoese",
        Units: "Ühikut",
        Pieces: "Tükki",
        Date: "Kuupäev",
        Reports: "Aruanded",
        Location: "Asukoht",
        Quantity: "Kogus",
        CurrentQuantity: "Praegune kogus",
        PieceQuantity: "Tükkide kogus",
        OpenedQuantity: "Avatud ühikus tükkide kogus",
        MinimumLevel: "Miinimumtase",
        MaximumLevel: "Maksimumtase",
        ReorderPoint: "Täiendamispunkt",
        ReorderQuantity: "Täiendamiskogus",
        BatchNumber: "Partii number",
        ExpiryDate: "Aegumiskuupäev",
        PackageOpenDate: "Ühiku avamiskuupäev",
        LastMovement: "Viimane liikumine",
        BatchLabel: "Partii",
        ExpiryLabel: "Aeg",
        NotAvailable: "Pole",
        Min: "Min",
        Max: "Max",
        Batch: "Partii",
        Expires: "Aegub",
        MinMaxLevels: "Min/Max tase",
        BatchExpiry: "Partii/Aegumine",
        StockArticle: "Laoartikkel",
        SelectArticle: "Vali artikkel",
        SelectResidents: "Vali elanik",
        SelectStockLevels: "Vali laotase",
        SelectStockLevel: "Vali laotase",
        FromStockLevel: "Lähtelaotase",
        ToStockLevel: "Sihtlaotase",
        FromLevel: "Lähteallikas",
        ToLevel: "Sihtkoht",
        Note: "Märkus",
        SelectDestinationLevel: "Vali sihtlaotase",
        SelectLevelWithStock: "Vali laotase, kus on saadaolevaid esemeid (kogus > 0)",
        AvailableArticles: "Saadaolevad artiklid",
        SelectedArticle: "Valitud artikkel",
        StockItemDetails: "Laoartikli üksikasjad",
        StockItemDetail: "Laoartikli üksikasi",
        PleaseSelectArticle: "Palun valige artikkel jätkamiseks",
        NoArticlesFound: "Artikleid ei leitud",
        TryDifferentSearch: "Proovige muuta otsingutermineid või filtreid",
        AllResidents: "Kõik elanikud",
        Resident: "Elanik",
        Cost: "Maksumus",
        Dashboard: "Töölaud",
        Code: "Kood",
        EnterLocation: "Sisesta asukoht",
        EnterQuantity: "Sisesta kogus",
        EnterPackageQuantity: "Sisesta ühikute kogus",
        UnitsSuffix: "ühikut",
        PiecesSuffix: "tükki",
        PackagesSuffix: "ühikut",
        EnterMinLevel: "Sisesta miinimumtase",
        FullPackagesCount: "Täielikud, avamata ühikud (konteinerid)",
        LoosePiecesFromOpenedUnits: "Üksikud tükid avatud ühikutest",
        PiecesPerUnit: "Tükki ühikus",
        TotalPieces: "Tükki kokku",
        TotalUnits: "Ühikuid kokku",
        TotalPurchaseValue: "Ostuväärtus kokku",
        CostPerPiece: "Hind tüki kohta",
        CostPerUnit: "Hind ühiku kohta",
        StockValue: "Lao väärtus",
        WillBeNormalizedTo: "Normaliseeritakse",
        EnterMaxLevel: "Sisesta maksimumtase",
        EnterReorderPoint: "Sisesta täiendamispunkt",
        EnterReorderQuantity: "Sisesta täiendamiskogus",
        EnterBatchNumber: "Sisesta partii number",
        SelectExpiryDate: "Vali aegumiskuupäev",
        ReorderPointHelp: "Koguse tase, mis käivitab täiendamise hoiatuse",
        ReorderQuantityHelp: "Soovitatav tellimiskogus",
        SearchByArticleOrLocation: "Otsi artikli nime, koodi või asukoha järgi",
        FilterByArticle: "Filtreeri artikli järgi",
        FilterByStockStatus: "Filtreeri laostaatuse järgi",
        FilterByMainLevel: "Filtreeri põhitaseme järgi",
        AllStock: "Kogu ladu",
        InStock: "Laos",
        LowStock: "Vähene ladu",
        OutOfStock: "Laost otsas",
        ShowAllStock: "Näita kogu ladu",
        ShowLowStockOnly: "Näita ainult vähest ladu",
        ShowAllLevels: "Näita kõiki tasemeid",
        ShowLowStockLevels: "Näita vähest ladu",
        LevelType: "Taseme tüüp",
        IsMainLevel: "On põhitase?",
        MainLevel: "Põhitase",
        SubLevel: "Alamtase",
        MainLevels: "Põhitasemed",
        SubLevels: "Alamtasemed",
        TotalItems: "Kokku esemeid",
        StockDashboard: "Lao töölaud",
        TotalStockValue: "Lao koguväärtus",
        InventoryValue: "Varude väärtus",
        LowStockItems: "Vähese laoga esemed",
        ItemsBelowMinimum: "Esemed alla miinimumi",
        ExpiredItems: "Aegunud esemed",
        RequireAttention: "Vajavad tähelepanu",
        ActiveItems: "Aktiivsed esemed",
        StockValueTrend: "Lao väärtuse trend",
        StockValueByLocation: "Lao väärtus asukoha järgi",
        InvoicedVsNonInvoiced: "Arveldatud vs arveldamata esemed",
        Invoiced: "Arveldatud",
        NotInvoiced: "Arveldamata",
        TopArticlesByValue: "Parimad artiklid väärtuse järgi",
        Value: "Väärtus",
        LowStockArticles: "Vähese laoga artiklid",
        ExpiringItems: "Aeguvad esemed",
        AllLevels: "Kõik tasemed",
        WithLowStock: "Vähese laoga",
        NoLowStock: "Ilma vähese laota",
        WithExpiringItems: "Aeguvate esemetega",
        Expiring: "Aegub",
        StockLevelCreated: "Laoseis loodud edukalt",
        StockLevelUpdated: "Laoseis uuendatud edukalt",
        AssignmentDeletedSuccess: "Määramine edukalt kustutatud",
        ErrorLoadingArticles: "Viga laoartiklite laadimisel",
        ErrorLoadingStockLevel: "Viga laoseisu laadimisel",
        AddStockArticle: "Lisa Artikkel",
        StockArticleCreated: "Laoartikkel edukalt loodud"
        ,
        // Stock movement translations
        RecordMovement: "Registreeri liikumine",
        QuickRecordDescription: "Kiiresti registreeri lao liikumised, korrigeerimised ja ümberpaigutused",
        RefReason: "Viide / Põhjus",
        LoadMovementsError: "Liikumiste laadimine ebaõnnestus",
        MovementRecorded: "Liikumine edukalt salvestatud",
        RecordMovementError: "Liikumise salvestamine ebaõnnestus",
        Reason: "Põhjus",
        Available: "Saadaval",
        AvailableUnits: "Saadaolevad ühikud",
        UnitsAvailable: "{count} ühikut saadaval",
        ExceedsAvailable: "Ületab saadaolevaid ühikuid ({available})",
        PurchaseCostPerUnit: "Ostuhind ühiku kohta",
        EnterPurchaseCost: "Sisestage ostuhind ühiku kohta",
        PurchaseCostDescription: "Tegelik hind, mis maksti selle konkreetse partii/koguse eest. Kasutatakse täpsete arvete arvutamiseks.",
        BulkAddItems: "Lisa hulgimahus kaupu",
        BulkItemsAdded: "Laokaubad edukalt lisatud",
        BulkItemsAddError: "Laokaupu ei õnnestunud lisada",
        SelectResidentStockLevel: "Vali elaniku laotase, et lisada kaupu",
        PackageQuantity: "Pakendite kogus"
    },
    stockLevel: {
        AssignmentDetailHeader: "Laoseisu määramine"
    },
    dashboard: {
            BookService: "Broneeri teenus",
        Welcome: "Tere tulemast Akersoni teenused",
        BookingManagementSystem: "Teraapia broneerimise haldussüsteem",
        TodayBookings: "Tänased broneeringud",
        ConfirmedBookings: "Kinnitatud",
        TotalClients: "Kokku kliente",
        ActiveServices: "Aktiivsed teenused",
        QuickActions: "Kiirtoimingud",
        MyBookings: "Minu broneeringud",
        ViewAndManageYourBookings: "Vaata ja halda oma broneeringuid",
        UpcomingBookings: "Tulevased broneeringud",
        YourNext10Bookings: "Teie järgmised 10 broneeringut",
        NoUpcomingBookings: "Tulevasi broneeringuid ei ole"
    },
    booking: {
        CreateBooking: "Loo broneering",
        ViewBookings: "Vaata broneeringuid",
        ManageBookings: "Halda broneeringuid",
        Bookings: "Broneeringud",
        CalendarTitle: "Broneerimiskalender",
        Calendar: "Kalender",
        EditBooking: "Muuda broneeringut",
        BookingSaved: "Broneering edukalt salvestatud",
        SaveFailed: "Broneeringu salvestamine ebaõnnestus",
        Client: "Klient",
        Service: "Teenus",
        Employee: "Töötaja",
        Room: "Ruum",
        Status: "Staatus",
        StartDate: "Alguskuupäev",
        EndDate: "Lõppkuupäev",
        StartDateTime: "Alguskuupäev/-kellaaeg",
        EndDateTime: "Lõppkuupäev/-kellaaeg",
        BookingTime: "Broneeringu aeg",
        Participants: "Osalejad",
        Notes: "Märkused",
        InternalComment: "Sisemine märkus",
        CancellationReason: "Tühistamise põhjus",
        ConflictDetected: "Konflikt tuvastatud",
        ConflictEmployeeBooked: "Töötaja on sel ajal juba broneeritud",
        ConflictRoomOccupied: "Ruum on sel ajal juba hõivatud",
        ConflictTimeUnavailable: "Valitud ajavahemik pole saadaval",
        ConflictCapacityExceeded: "Selle teenuse maksimaalne mahutavus on ületatud",
        PublicHolidayDayOff: "Valitud aeg langeb riigipühale, mis on märgitud vabaks päevaks",
        ConflictGeneric: "Broneeringu konflikt tuvastatud",
        ClearConflict: "Sulge",
        Templates: "Mallid",
        SlotsRemaining: "kohta vaba",
        ParticipantsFilled: "osalejat täidetud",
        Full: "Täis",
        MaxCapacityReached: "Maksimaalne mahutavus saavutatud",
        Selected: "valitud",
        PreHoldExpiring: "Eelbroneering aegub varsti",
        Expired: "Aegunud",
        Remaining: "järel",
        SelectClient: "Vali klient",
        SelectService: "Vali teenus",
        SelectEmployee: "Vali töötaja",
        SelectRoom: "Vali ruum",
        BookingStatus: "Broneeringu staatus",
        SelectStatus: "Vali staatus",
        SelectParticipants: "Vali osalejad",
        SelectCancellationReason: "Vali tühistamise põhjus",
        EnterNotes: "Sisesta märkused",
        EnterInternalComment: "Sisesta sisemine märkus",
        DropBookingsHere: "Kukuta broneeringud siia",
        NoService: "Teenus puudub",
        NoEmployee: "Töötaja puudub",
        NoStatus: "Staatus puudub",
        SpecialClient: "Eriklient",
        FilterByEmployee: "Filtreeri töötaja järgi",
        AllEmployees: "Kõik töötajad",
        AllStatuses: "Kõik staatused",
        WeekView: "Nädalavaade",
        DayView: "Päevavaade",
        Today: "Täna",
        Week: "Nädal",
        Day: "Päev",
        ShowTemplates: "Näita malle",
        HideTemplates: "Peida mallid",
        StatusPreHold: "Eelbroneering",
        StatusConfirmed: "Kinnitatud",
        StatusCompleted: "Lõpetatud",
        StatusCancelled: "Tühistatud",
        StatusWaitlisted: "Ootejärjekorras",
        BookingDetails: "Broneeringu üksikasjad",
        CreateNewBooking: "Loo uus broneering",
        SelectedTime: "Valitud aeg",
        FormComingSoon: "Broneerimise vorm tuleb varsti",
        Updated: "Broneering edukalt uuendatud",
        UpdateFailed: "Broneeringu uuendamine ebaõnnestus",
        ExpiresIn: "Aegub",
        ServiceInformation: "Teenuse info",
        DateTime: "Kuupäev ja kellaaeg",
        LeadClient: "Põhiklient",
        NotFound: "Broneeringut ei leitud",
        CancelBooking: "Tühista broneering",
        CancelConfirmation: "Kas olete kindel, et soovite selle broneeringu tühistada?",
        SelectReason: "Vali põhjus",
        CancellationNotesPlaceholder: "Valikulised märkused tühistamise kohta...",
        Approve: "Kinnita",
        ApproveFallback: "Kinnita",
        Reject: "Keeldu",
        RejectFallback: "Keeldu",
        BookingApproved: "Broneering edukalt kinnitatud",
        ApproveFailed: "Broneeringu kinnitamine ebaõnnestus",
        BookingRejected: "Broneering edukalt tagasi lükatud",
        RejectFailed: "Broneeringu tagasilükkamine ebaõnnestus",
        Confirmed: "Broneering edukalt kinnitatud",
        ConfirmFailed: "Broneeringu kinnitamine ebaõnnestus",
        Cancelled: "Broneering edukalt tühistatud",
        CancelFailed: "Broneeringu tühistamine ebaõnnestus",
        LoadFailed: "Broneeringu laadimine ebaõnnestus",
        LoadBookingsFailed: "Broneeringute laadimine ebaõnnestus",
        CreatedSuccessfully: "Broneering edukalt loodud",
        CreateFailed: "Broneeringu loomine ebaõnnestus",
        SendNotificationPrompt: "Kas soovite saata e-posti teavituse põhikliendile?",
        SendNotification: "Saada teavitus",
        ConfirmSendNotification: "Kas saata broneeringu teavitus sellele kliendile?",
        DontSendNotification: "Ära saada",
        LeadClientNoUser: "Hoiatus: Põhikliendil puudub kasutajakonto ja ta ei saa e-posti teavitusi.",
        EmployeeConflict: "Töötaja on sel ajal juba broneeritud. Palun valige erinev aeg või töötaja.",
        RoomConflict: "Ruum on sel ajal juba hõivatud. Palun valige erinev aeg või ruum.",
        ClientConflict: "Üks või mitu klienti on sel ajal juba broneeritud. Palun valige erinev aeg.",
        MissingSkills: "Nõutavad oskused puuduvad",
        StartTime: "Algusaeg",
        EndTime: "Lõppaeg",
        EndsAt: "Lõpeb kell",
        AdditionalParticipants: "Lisaosalejad",
        SelectAdditionalClients: "Vali lisaosalejad",
        ParticipantsSingular: "osaleja",
        ParticipantsPlural: "osalejat",
        NoClientRequired: "Klient pole nõutav",
        NoClientRequiredTooltip: "Märkige see konsultatsioonide või ülevaadete jaoks potentsiaalsete klientidega, kes pole veel süsteemis",
        CapacityAvailable: "{count} kohta vaba",
        IndividualServiceOneParticipant: "Individuaalteenus - ainult 1 osaleja lubatud",
        CapacityExceeded: "Mahutavus ületatud - maksimaalselt {max} osalejat lubatud",
        "Conflict.EMPLOYEE_BOOKED": "Töötaja on sel ajal juba broneeritud",
        "Conflict.ROOM_OCCUPIED": "Ruum on sel ajal juba hõivatud",
        "Conflict.TIME_UNAVAILABLE": "Valitud ajavahemik pole saadaval",
        "Conflict.CAPACITY_EXCEEDED": "Maksimaalne mahutavus on ületatud",
        NoTemplatesAvailable: "Teenuse malle pole saadaval",
        NoBookingsFound: "Broneeringuid ei leitud",
        BookingDetail: "Broneeringu andmed",
        ClientCancelled: "Klient tühistas",
        StaffCancelled: "Personal tühistas",
        NoShow: "Ei ilmunud",
        Rescheduled: "Ümber planeeritud",
        Confirm: "Kinnita",
        // Bulk Available Slots
        CreateBulkAvailableSlots: "Loo hulgi vabad ajad",
        CreateMultipleBookings: "Loo mitu broneeringut",
        AddMultipleDates: "Lisa mitu kuupäeva",
        DuplicateToMultipleDates: "Dubleeri mitmele kuupäevale",
        BulkSlotsCreatedSuccess: "{count} vaba aja slot(i) edukalt loodud",
        BulkSlotsCreationFailed: "Vabade aegade loomine ebaõnnestus",
        MultipleBookingsCreatedSuccess: "{count} broneering(ut) loodi edukalt",
        MultipleBookingsCreatedPartial: "Loodi {created} broneering(ut), vahele jäi {skipped}",
        SelectStartDate: "Vali alguskuupäev",
        SelectEndDate: "Vali lõppkuupäev",
        SelectStartTime: "Vali algusaeg",
        SelectEndTime: "Vali lõppaeg",
        PreferredTime: "Eelistatud aeg",
        PreferredStartTime: "Eelistatud algusaeg",
        PreferredTimeHelp: "Kuupäeva valimisel proovib süsteem esmalt seda aega. Kui see pole vaba, vali selle päeva soovitatud aegade seast.",
        QuickTimes: "Kiirajad",
        NoQuickTimesYet: "Hiljutisi aegu veel pole",
        CustomPreferredTime: "Kohandatud eelistatud aeg",
        TemplateParticipants: "Osalejad",
        SelectAdditionalDates: "Vali lisakuupäevad",
        SelectAdditionalDatesHelp: "Rohelised päevad toetavad sinu eelistatud aega. Kollastel päevadel on muud vabad ajad. Hallid päevad ei ole saadaval.",
        DayHasPreferredTime: "Eelistatud aeg on saadaval",
        DayHasAlternativeTimes: "Alternatiivsed ajad on saadaval",
        DayUnavailable: "Vabu aegu ei ole",
        SelectedDates: "Valitud kuupäevad",
        SelectedDatesCount: "{count} valitud",
        NoDatesSelected: "Ühtegi kuupäeva pole veel valitud",
        Ready: "Valmis",
        NeedsTimeSelection: "Vajab aega",
        ChooseTimeForDate: "Vali sellele kuupäevale aeg",
        AvailableTimesForDay: "Valitud päeva vabad ajad",
        SelectDateToSeeTimes: "Vali kuupäev, et näha vabu aegu",
        NoTimeSlotsAvailableForDate: "Sellele kuupäevale pole vabu aegu",
        LoadAvailabilityFailed: "Saadavuse laadimine ebaõnnestus",
        SelectedSlotNoLongerAvailable: "Valitud aeg ei ole enam saadaval. Palun vali uuesti.",
        BookingsCreatedCount: "Loodud: {count}",
        BookingsSkippedCount: "Vahele jäetud: {count}",
        BulkBookingFooterHelp: "Enne salvestamist peab igale valitud kuupäevale olema määratud aeg.",
        TemplateBuildFailed: "Broneeringu malli ettevalmistamine ebaõnnestus",
        DaysOfWeek: "Nädalapäevad",
        DaysOfWeekHelp: "Vali, millistel nädalapäevadel luua aegu",
        SlotDuration: "Ajavahemiku kestus",
        UseDefaultRoom: "Kasuta vaikimisi ruumi (jäta tühjaks)",
        RoomOptionalHelp: "Kui ruum ei ole valitud, kasutatakse töötaja vaikimisi ruumi",
        CreationSummary: "Loomise kokkuvõte",
        SlotsCreated: "Loodud ajad",
        SlotsSkipped: "Vahele jäetud ajad",
        SkippedDetails: "Vahele jäetud aegade detailid",
        SlotsSkippedMessage: "{count} aega jäeti vahele konfliktide tõttu",
        FixedSlotTemplate: "Fikseeritud teenuse aeg",
        FixedSlotMissingEmployee: "Töötaja on veel määramata"
    },
    service: {
        ManageServices: "Halda teenuseid",
        Services: "Teenused",
        Service: "Teenus",
        Name: "Teenuse nimi",
        ServiceName: "Teenuse nimi",
        Category: "Kategooria",
        ServiceType: "Teenuse tüüp",
        SelectServiceType: "Vali teenuse tüüp",
        ServiceTypeHelp: "Valikuline klassifikatsioon teenuste organiseerimiseks",
        Duration: "Kestus",
        Minutes: "minutit",
        Price: "Hind",
        MaxCapacity: "Maksimaalne mahutavus",
        Description: "Kirjeldus",
        IsActive: "Aktiivne",
        IsPublic: "Avalikuks",
        IsPassEligible: "Passile sobiv",
        PassEligible: "Passile sobiv",
        IsPayable: "Vajab makset",
        ClientType: "Kliendi tüüp",
        SelectClientType: "Vali kliendi tüüp",
        ClientTypeHelp: "Valikuline - määrake, millise kliendi tüübi jaoks see teenus on (Täiskasvanu, Laps jne)",
        ServiceMarkedPublic: "Teenus märgitud avalikuks broneerimiseks kättesaadavaks",
        ServiceMarkedPrivate: "Teenus märgitud privaatseks (avalikuks broneerimiseks mitte kättesaadav)",
        ErrorUpdatingService: "Viga teenuse värskendamisel",
        CreateService: "Loo teenus",
        EditService: "Muuda teenust",
        EnterName: "Sisesta teenuse nimi",
        SelectCategory: "Vali kategooria",
        EnterDuration: "Sisesta kestus minutites",
        EnterPrice: "Sisesta hind",
        EnterMaxCapacity: "Sisesta maksimaalne mahutavus",
        EnterDescription: "Sisesta teenuse kirjeldus",
        FilterByCategory: "Filtreeri kategooria järgi",
        FilterByStatus: "Filtreeri staatuse järgi",
        ServiceSaved: "Teenus salvestatud edukalt",
        ServiceDeleted: "Teenus kustutatud edukalt",
        ErrorLoadingService: "Viga teenuse laadimisel",
        ErrorSavingService: "Viga teenuse salvestamisel",
        ErrorDeletingService: "Viga teenuse kustutamisel",
        ConfirmDelete: "Kas olete kindel, et soovite selle teenuse kustutada?",
        IndividualHelpText: "Üks-ühele teraapiaseanss",
        GroupHelpText: "Grupiteraapia - mitu osalejat",
        IndividualCapacityFixed: "Individuaalse teenuse mahutavus on alati 1",
        DisplayedAs: "Kuvatakse kui",
        QuickDuration: "Kiirvalik kestus",
        Code: "Teenuse Kood",
        CodePlaceholder: "nt PT-60, MT-45, GRP-T",
        CodeHelp: "Soovitatud formaat: [Kategooria]-[Kestus]",
        AccountingCode: "Raamatupidamise kood",
        AccountingCodePlaceholder: "nt ACCT-001",
        Color: "Teenuse Värv",
        SelectColor: "Vali Värv",
        IndividualServices: "Individuaalsed teenused",
        GroupServices: "Grupi teenused",
        RequiredSkills: "Nõutavad oskused",
        SelectRequiredSkills: "Vali nõutavad oskused",
        RequiredSkillsHelp: "Töötajatel peavad olema need oskused selle teenuse pakkumiseks",
        AssignedEmployee: "Määratud töötaja",
        SelectService: "Vali teenus",
        SelectEmployee: "Vali töötaja",
        SelectSkillsFirst: "Vali kõigepealt nõutavad oskused",
        AssignedEmployeeHelp: "Selle teenuse vaikimisi töötaja",
        AssignedRoom: "Määratud ruum",
        SelectRoom: "Vali ruum",
        AssignedRoomHelp: "Selle teenuse vaikimisi ruum",
        AddNewService: "Lisa uus teenus",
        IsSpecial: "Eriteenus (VIP/eelisjärjekord)",
        UseFixedSlots: "Kasuta graafikut",
        FixedSlotsHelp: "Kui see on sisse lülitatud, public booking ajad luuakse ainult nendest päeva/kella reeglitest.",
        FixedSlotTimeInvalid: "Sisesta algusaeg formaadis HH:mm",
        StartTime: "Algusaeg",
        PassEligibilityEnabled: "Pakettide õigus lubatud teenusele {serviceName}",
        PassEligibilityDisabled: "Pakettide õigus keelatud teenusele {serviceName}"
    },
    servicePass: {
        ServicePasses: "Teenuste paketid",
        ServicePass: "Teenuse pakett",
        Passes: "Paketid",
        ManageServicePasses: "Halda teenuste pakette",
        CreateServicePass: "Loo teenuse pakett",
        EditServicePass: "Muuda teenuse paketti",
        PassDefinitions: "Paketi definitsioonid",
        ClientPasses: "Kliendi paketid",
        SelectClientToViewPasses: "Vali klient, et vaadata tema pakette",
        SelectClientFirst: "Palun vali kõigepealt klient, et vaadata tema pakette",
        Owner: "Omanik",
        Sessions: "Seansid",
        PassName: "Paketi nimi",
        PassNameHelp: "Klientidele kuvatav paketi nimi",
        PassDescription: "Kirjeldus",
        SessionCount: "Seansside arv",
        Price: "Koguhind",
        ValidityDays: "Kehtivusaeg (päevades)",
        IsActive: "Aktiivne",
        PricePerSession: "Hind seansi kohta",
        HasExpiry: "On aegumiskuupäev",
        SetExpiryPeriod: "Määra kehtivusaeg",
        NoExpiry: "Kehtib lõputult",
        SelectService: "Vali teenus",
        SelectServiceFirst: "Palun vali kõigepealt teenus",
        EnterPassName: "Sisesta paketi nimi",
        EnterDescription: "Sisesta kirjeldus",
        EnterSessionCount: "Sisesta seansside arv",
        EnterPrice: "Sisesta koguhind",
        EnterValidityDays: "Sisesta kehtivusaeg päevades",
        SessionCountHelp: "Paketti kuuluvate seansside koguarv",
        PriceHelp: "Kõigi paketi seansside koguhind",
        ValidityDaysHelp: "Päevade arv ostukuupäevast, millal pakett aegub (jäta tühjaks, kui ei aegu)",
        PassNameRequired: "Paketi nimi on kohustuslik",
        SessionCountRequired: "Seansside arv on kohustuslik",
        SessionCountRange: "Seansside arv peab olema vahemikus 1-100",
        PriceRequired: "Hind on kohustuslik",
        PricePositive: "Hind peab olema positiivne",
        ValidityDaysRange: "Kehtivusaeg peab olema vahemikus 1-365 päeva",
        ServicePassSaved: "Teenuse pakett salvestatud",
        ServicePassDeleted: "Teenuse pakett kustutatud",
        ErrorLoadingPasses: "Viga teenuste pakettide laadimisel",
        ErrorSavingPass: "Viga teenuse paketi salvestamisel",
        ErrorDeletingPass: "Viga teenuse paketi kustutamisel",
        ConfirmDelete: "Kas oled kindel, et soovid kustutada selle teenuse paketi?",
        EmptyStateMessage: "Selle teenuse jaoks ei leitud pakette. Loo pakett, et pakkuda klientidele seansside pakette.",
        CreateFirstPass: "Loo oma esimene teenuse pakett",
        MyPasses: "Minu paketid",
        PurchasePass: "Osta pakett",
        PassDetails: "Paketi üksikasjad",
        RemainingSessionsLabel: "Järelejäänud",
        SessionsUsed: "Kasutatud seansid",
        PurchaseDate: "Ostukuupäev",
        ExpiryDate: "Aegumiskuupäev",
        ExpiryDateOptional: "Aegumiskuupäev on valikuline. Jäta tühjaks, kui ei aegu.",
        Status: "Staatus",
        UsageHistory: "Kasutusajalugu",
        ViewUsageHistory: "Vaata kasutusajalugu",
        ViewUsage: "Vaata kasutust",
        NoUsageHistory: "Kasutusajalugu ei leitud",
        UsedOn: "Kasutatud",
        BookingReference: "Broneeringu viide",
        Active: "Aktiivne",
        Depleted: "Ammendatud",
        Expired: "Aegunud",
        Cancelled: "Tühistatud",
        PassPurchased: "Pakett ostetud",
        ErrorPurchasingPass: "Viga paketi ostmisel",
        ErrorUpdatingPass: "Viga paketi uuendamisel",
        ErrorLoadingPassDetails: "Viga paketi üksikasjade laadimisel",
        ErrorLoadingUsageHistory: "Viga kasutusajaloo laadimisel",
        SelectPass: "Vali pakett",
        AvailablePasses: "Saadaolevad paketid",
        NoPasses: "Pakette pole saadaval",
        NoClientProfile: "Kliendi profiili ei leitud. Palun võtke ühendust toega.",
        PassProgress: "Paketi edenemine",
        SessionsRemaining: "{count} seanss(i) järel",
        PassExpiring: "Aegub {days} päeva pärast",
        PassExpired: "See pakett on aegunud",
        PurchaseForChild: "Valikuline - osta see pakett konkreetsele lapsele või jäta tühjaks, et osta endale",
        ErrorLoadingServices: "Viga teenuste laadimisel",
        SearchClientOrChild: "Otsi klienti või last",
        OwnerHelp: "Otsi ja vali klient või tema laps, kes omab seda paketti",
        EditClientPass: "Muuda kliendi paketti",
        EditNotSupported: "Ostetud pakettide muutmine ei ole praegu toetatud",
        HasActivePass: "Omab aktiivset paketti selle teenuse jaoks",
        PassSessionsRemaining: "{remaining} / {total} sessiooni alles",
        RemainingSessions: "Järelejäänud seansid",
        RemainingSessionsHelp: "Valikuline: määra selle paketi algne järelejäänud seansside arv.",
        RemainingSessionsPlaceholder: "Vaikimisi: {total}",
        SessionsUsedHelp: "Sisesta, mitu korda on paketti juba kasutatud. See muudab järelejäänud seansside arvu, kuid ei lisa tagantjärele kasutusajalukku kirjeid.",
        AddBookingUsage: "Lisa kasutatud broneering",
        AddBookingUsageHelp: "Ava valik ja lisa olemasolev minevikus toimunud broneering samale omanikule ja samale teenusele.",
        SelectBookingUsage: "Vali kasutatud broneering",
        SelectBookingUsageHelp: "Kuvatakse ainult sama omaniku, sama teenuse ja minevikus toimunud broneeringud, mida pole veel selle paketiga seotud.",
        EligibleBookings: "Sobivaid broneeringuid: {count}",
        NoEligibleBookingsForPass: "Selle paketi jaoks sobivaid broneeringuid ei leitud.",
        ErrorLoadingEligibleBookings: "Sobivate broneeringute laadimine ebaõnnestus",
        BookingUsageAdded: "Broneering lisati paketi kasutusajalukku",
        ErrorAddingBookingUsage: "Broneeringu lisamine paketi kasutusena ebaõnnestus",
        ActiveServicePasses: "Aktiivsed teenusepaketid",
        NoPassEligibleServices: "Pakettidele sobivaid teenuseid ei leitud. Lubage esmalt pakettide õigus teenuse seadetes.",
        OnlyPassEligibleServicesShown: "Kuvatakse ainult pakettidele sobivad teenused.",
        ManageServices: "Halda teenuseid",
        ManagePassEligibility: "Halda teenuste paketi õigust",
        BeforeBooking: "enne broneeringut"
    },
    employee: {
        Employees: "Töötajad",
        Employee: "Töötaja",
        Therapist: "Terapeut",
        ManageEmployees: "Halda töötajaid",
        CreateEmployee: "Loo töötaja",
        EditEmployee: "Muuda töötajat",
        EmployeeDetail: "Töötaja andmed",
        Name: "Nimi",
        FirstName: "Eesnimi",
        LastName: "Perekonnanimi",
        Email: "E-post",
        Phone: "Telefon",
        User: "Kasutaja",
        Status: "Staatus",
        Skills: "Oskused",
        IsActive: "Aktiivne",
        BasicInfo: "Põhiandmed",
        Qualifications: "Kvalifikatsioonid",
        WorkSchedules: "Töögraafikud",
        Unavailability: "Puudumine",
        Bookings: "Broneeringud",
        SelectEmployee: "Vali töötaja",
        SelectStatus: "Vali staatus",
        SelectSkills: "Vali oskused",
        EnterFirstName: "Sisesta eesnimi",
        EnterLastName: "Sisesta perekonnanimi",
        EnterEmail: "Sisesta e-posti aadress",
        EnterPhone: "Sisesta telefoninumber",
        FirstNameRequired: "Eesnimi on kohustuslik",
        LastNameRequired: "Perekonnanimi on kohustuslik",
        StatusRequired: "Staatus on kohustuslik",
        EmployeeRequired: "Töötaja on kohustuslik",
        LoadError: "Töötajate laadimine ebaõnnestus",
        LinkedUser: "Seotud kasutajakonto",
        SelectUser: "Vali kasutajakonto (valikuline)",
        NoUsersAvailable: "Kasutajaid pole saadaval",
        UserMappingHint: "Seo see töötaja kasutajakontoga süsteemi juurdepääsuks. See on valikuline ja seda saab teha hiljem.",
        FailedToLoadUsers: "Kasutajate laadimine ebaõnnestus",
        EmployeeCreated: "Töötaja edukalt loodud",
        EmployeeUpdated: "Töötaja edukalt uuendatud",
        EmployeeDeleted: "Töötaja edukalt kustutatud",
        SaveFailed: "Töötaja salvestamine ebaõnnestus",
        LoadFailed: "Töötaja andmete laadimine ebaõnnestus",
        SkillsDescription: "Halda töötaja oskusi ja pädevusi",
        QualificationsDescription: "Jälgi töötaja kvalifikatsioone, sertifikaate ja aegumiskuupäevi",
        WorkSchedulesDescription: "Määra korduvad töögraafikud ja saadavuse mustrid",
        UnavailabilityDescription: "Halda töötaja puudumisi ja vabade aegade plokeerimist",
        QualificationsComingSoon: "Kvalifikatsioonide haldamine tulekul",
        WorkSchedulesComingSoon: "Töögraafikute haldamine tulekul",
        UnavailabilityComingSoon: "Puudumiste haldamine tulekul",
        AddSchedule: "Lisa töögraafik",
        EditSchedule: "Muuda töögraafikut",
        NoSchedulesDefined: "Töögraafikuid pole määratud",
        AddFirstSchedule: "Lisa esimene töögraafik",
        DayOfWeek: "Nädalapäev",
        StartTime: "Algusaeg",
        EndTime: "Lõppaeg",
        TimeFormat: "00:00",
        RecurringPattern: "Kordumismuster",
        SelectRecurringPattern: "Vali kordumismuster",
        EffectiveFrom: "Kehtiv alates",
        EffectiveTo: "Kehtiv kuni",
        SelectDate: "Vali kuupäev",
        SelectDay: "Vali päev",
        SelectDays: "Vali päevad",
        ScheduleCreated: "Töögraafik edukalt loodud",
        ScheduleUpdated: "Töögraafik edukalt uuendatud",
        FailedToLoadSchedules: "Töögraafikute laadimine ebaõnnestus",
        FailedToSaveSchedule: "Töögraafiku salvestamine ebaõnnestus",
        FilterByActive: "Filtreeri aktiivsuse järgi",
        AcquiredDate: "Omandamise kuupäev",
        ExpiresOn: "Aegub",
        CertificationNumber: "Sertifikaadi number",
        NoExpiry: "Ei aegu",
        Expired: "Aegunud",
        ExpiringSoon: "Aegub {days} päeva pärast",
        Valid: "Kehtiv",
        NoQualifications: "Kvalifikatsioone pole määratud",
        AddQualification: "Lisa kvalifikatsioon",
        EditQualification: "Muuda kvalifikatsiooni",
        QualificationRequired: "Kvalifikatsioon on kohustuslik",
        QualificationSaved: "Kvalifikatsioon edukalt salvestatud",
        SaveQualificationFailed: "Kvalifikatsiooni salvestamine ebaõnnestus",
        LoadQualificationsFailed: "Kvalifikatsioonide laadimine ebaõnnestus",
        SelectAcquiredDate: "Vali omandamise kuupäev",
        SelectExpiryDate: "Vali aegumiskuupäev (valikuline)",
        ExpiryDateOptional: "Jäta tühjaks, kui kvalifikatsioon ei aegu",
        EnterCertificationNumber: "Sisesta sertifikaadi/litsentsi number",
        EnterNotes: "Sisesta lisamärkused",
        Absences: "Puudumised",
        CreateAbsence: "Loo puudumine",
        EditAbsence: "Muuda puudumist",
        AbsenceCreated: "Puudumine edukalt loodud",
        AbsenceDeleted: "Puudumine edukalt kustutatud",
        AbsenceFailed: "Puudumise haldamine ebaõnnestus",
        LoadAbsencesFailed: "Puudumiste laadimine ebaõnnestus",
        NoAbsences: "Puudumisi pole",
        AbsenceStartTime: "Puudumise algus",
        AbsenceEndTime: "Puudumise lõpp",
        AbsenceReason: "Puudumise põhjus",
        AbsenceReasonOptional: "Põhjus on valikuline",
        SelectAbsenceReason: "Vali põhjus (valikuline)",
        AbsenceStartRequired: "Algusaeg on kohustuslik",
        AbsenceEndRequired: "Lõppaeg on kohustuslik",
        AbsenceCannotBePast: "Puudumine ei saa olla minevikus",
        AbsenceOverlapError: "See puudumine kattub olemasoleva puudumisega",
        AbsenceAffectedBookings: "Mõjutatud broneeringud",
        AbsenceSubstituteMatch: "Asenduse vaste",
        AbsenceNoSubstitute: "Asendus puudub",
        AbsenceBookingsWillBeCancelled: "Mõjutatud broneeringud tühistatakse, kui asendust ei leita",
        AbsenceBookingsReassigned: "Broneeringud ümber määratud asendusele",
        AbsenceBookingsCancelled: "Broneeringud tühistatud",
        AbsenceDeleteWarning: "Selle puudumise kustutamine EI taasta tühistatud broneeringuid",
        AbsenceAllDay: "Terve päev",
        AllDayAbsenceInfo: "Puudumine kehtib kogu päeva jooksul (00:00 – 24:00). Lõppaeg seaakse automaatselt järgmise päeva algusele.",
        NoReasonProvided: "Põhjust ei ole lisatud",
        DefaultRoom: "Vaikimisi ruum",
        SelectDefaultRoom: "Vali vaikimisi ruum (valikuline)",
        DefaultRoomHelp: "Seda ruumi kasutatakse vaikimisi vabade aegade loomisel",
        NoEmployeeRecordFound: "Teie konto jaoks ei leitud töötaja kirjet",
        ContactAdministrator: "Palun võtke ühendust administraatoriga, et siduda oma konto töötaja kirjega"
    },
    qualification: {
        Qualifications: "Kvalifikatsioonid",
        Qualification: "Kvalifikatsioon",
        ManageQualifications: "Halda kvalifikatsioone",
        Name: "Kvalifikatsiooni nimi",
        Code: "Kvalifikatsiooni kood",
        Description: "Kirjeldus",
        Category: "Kategooria",
        IsActive: "Aktiivne",
        RequiresExpiry: "Nõuab aegumist",
        ValidityPeriodMonths: "Kehtivusperiood (kuud)",
        CreateQualification: "Loo kvalifikatsioon",
        EditQualification: "Muuda kvalifikatsiooni",
        EnterName: "Sisesta kvalifikatsiooni nimi",
        EnterCode: "Sisesta kvalifikatsiooni kood",
        EnterDescription: "Sisesta kirjeldus",
        SelectCategory: "Vali kategooria",
        EnterValidityPeriod: "Sisesta kehtivusperiood kuudes",
        QualificationSaved: "Kvalifikatsioon salvestatud edukalt",
        QualificationDeleted: "Kvalifikatsioon kustutatud edukalt",
        ErrorLoadingQualifications: "Viga kvalifikatsioonide laadimisel",
        ErrorLoadingQualification: "Viga kvalifikatsiooni laadimisel",
        ErrorSavingQualification: "Viga kvalifikatsiooni salvestamisel",
        ErrorDeletingQualification: "Viga kvalifikatsiooni kustutamisel",
        NoQualificationsFound: "Kvalifikatsioone ei leitud",
        ValidityPeriodHelp: "Kuude arv, mil kvalifikatsioon kehtib (nt 12 aastase pikendamise jaoks)",
        RequiresExpiryHelp: "Luba, kui see kvalifikatsioon vajab perioodilist uuendamist"
    },
    room: {
        Room: "Ruum",
        Rooms: "Ruumid",
        RoomList: "Ruumide nimekiri",
        RoomDetails: "Ruumi andmed",
        CreateRoom: "Loo ruum",
        EditRoom: "Muuda ruumi",
        DeleteRoom: "Kustuta ruum",
        Name: "Ruumi nimi",
        Description: "Kirjeldus",
        Location: "Asukoht",
        Capacity: "Mahutavus",
        IsActive: "Aktiivne",
        SelectRoom: "Vali ruum",
        NameRequired: "Ruumi nimi on kohustuslik",
        CapacityRequired: "Mahutavus on kohustuslik",
        CapacityRange: "Mahutavus peab olema vahemikus 1 kuni 100",
        InsufficientCapacity: "Ruumi mahutavus ({roomCapacity}) on teenuse maksimaalse mahutavuse ({serviceCapacity}) jaoks ebapiisav",
        RoomCreated: "Ruum loodud edukalt",
        RoomUpdated: "Ruum uuendatud edukalt",
        RoomDeleted: "Ruum kustutatud edukalt",
        CannotDeleteWithBookings: "Ei saa kustutada ruumi, millel on tulevased broneeringud",
        ErrorLoadingRooms: "Viga ruumide laadimisel",
        ErrorSavingRoom: "Viga ruumi salvestamisel",
        ErrorDeletingRoom: "Viga ruumi kustutamisel",
        EmptyStateMessage: "Ruume ei leitud. Loo oma esimene terapiaruum broneeringute alustamiseks.",
        CreateFirstRoom: "Loo oma esimene ruum",
        EnterName: "Sisesta ruumi nimi",
        EnterDescription: "Sisesta kirjeldus",
        EnterLocation: "Sisesta asukoht",
        EnterCapacity: "Sisesta mahutavus",
        HasFutureBookings: "Sellel ruumil on {count} tulevast broneeringut ja seda ei saa kustutada"
    },
    client: {
            BirthDate: "Sünniaeg",
            Notes: "Märkused",
        Clients: "Kliendid",
        Client: "Klient",
        ClientName: "Kliendi nimi",
        ManageClients: "Halda kliente",
        CreateClient: "Loo klient",
        EditClient: "Muuda klienti",
        ClientDetail: "Kliendi andmed",
        ClientList: "Klientide nimekiri",
        ClientBookings: "Kliendi broneeringud",
        BasicInfo: "Põhiandmed",
        ServiceInfo: "Teenuste info",
        FirstName: "Eesnimi",
        LastName: "Perekonnanimi",
        Name: "Nimi",
        PersonalCode: "Isikukood",
        PhoneNumber: "Telefoninumber",
        Email: "E-post",
        Address: "Aadress",
        Category: "Kategooria",
        ClientType: "Kliendi tüüp",
        SelectClientType: "Vali kliendi tüüp",
        DefaultLanguage: "Eelistatud keel",
        SelectDefaultLanguage: "Vali eelistatud keel",
        DefaultLanguageHelp: "Keel teavituste ja kommunikatsiooni jaoks",
        PreferredServices: "Eelistatud teenuste tüübid",
        SelectPreferredServices: "Vali eelistatud teenuste tüübid",
        PreferredServicesHelp: "Kliendi/lapse poolt tavaliselt kasutatavad teenuste tüübid kiiremaks broneerimiseks",
        Preferences: "Eelistused",
        IsActive: "Aktiivne",
        InactiveReason: "Mitteaktiivsuse põhjus",
        EnterInactiveReason: "Sisesta mitteaktiivsuse põhjus",
        InactiveReasonHelp: "Kirjelda lühidalt, miks klient märgiti mitteaktiivseks. Näiteks: teenus lõpetatud, taastunud ja rohkem teenust ei vaja.",
        InactiveReasonRequired: "Mitteaktiivse kliendi puhul on põhjuse lisamine kohustuslik",
        NoInactiveReasonProvided: "Põhjust ei ole lisatud",
        InactiveStatusSummary: "Klient on märgitud mitteaktiivseks",
        HasUser: "Kasutaja",
        HasUserAccount: "On kasutaja",
        NoUserAccount: "Puudub kasutaja",
        UserAccount: "Kasutajakonto",
        SelectUserAccount: "Vali kasutajakonto (valikuline)",
        UserAccountOptional: "Kasutajakonto on valikuline - vajalik ainult kui klient logib sisse",
        SelectCategory: "Vali kategooria",
        SelectPreferences: "Vali eelistused",
        EnterFirstName: "Sisesta eesnimi",
        EnterLastName: "Sisesta perekonnanimi",
        EnterPersonalCode: "Sisesta Eesti isikukood",
        EnterPhoneNumber: "Sisesta telefoninumber",
        EnterEmail: "Sisesta e-posti aadress",
        EnterAddress: "Sisesta aadress",
        PersonalCodeHint: "11-kohaline Eesti isikukood",
        InvalidPersonalCode: "Vale isikukood. Palun kontrollige formaati ja kontrollsummat.",
        FilterByCategory: "Filtreeri kategooria järgi",
        FilterByClientType: "Filtreeri kliendi tüübi järgi",
        FirstNameRequired: "Eesnimi on kohustuslik",
        LastNameRequired: "Perekonnanimi on kohustuslik",
        PersonalCodeRequired: "Isikukood on kohustuslik",
        CategoryRequired: "Kategooria on kohustuslik",
        ClientCreatedSuccessfully: "Klient loodud edukalt",
        ClientUpdatedSuccessfully: "Klient uuendatud edukalt",
        ClientDeletedSuccessfully: "Klient kustutatud edukalt",
        FailedToCreateClient: "Kliendi loomine ebaõnnestus",
        FailedToUpdateClient: "Kliendi uuendamine ebaõnnestus",
        FailedToDeleteClient: "Kliendi kustutamine ebaõnnestus",
        FailedToLoadClient: "Kliendi laadimine ebaõnnestus",
        FailedToLoadClients: "Klientide laadimine ebaõnnestus",
        ServiceInfoDescription: "Vaata kliendi teenuste ajalugu ja tulevasi broneeringuid",
        LeadClient: "Põhiklient",
        SelectClient: "Vali klient",
        ServiceInfoComingSoon: "Teenuste info ja broneeringute ajalugu tulekohta",
        ClientChildren: "Kliendi lapsed",
        NoClientRecordFound: "Teie konto jaoks ei leitud kliendi kirjet",
        ContactAdministrator: "Abi saamiseks võtke ühendust administraatoriga",
        Myself: "Endale",
        SelectChild: "Vali laps"
    },
    clientChild: {
        Name: "Nimi",
        BasicInfo: "Põhiandmed",
        FirstName: "Eesnimi",
        LastName: "Perekonnanimi",
        IdentityCode: "Isikukood",
        BirthDate: "Sünniaeg",
        AddChild: "Lisa Laps",
        EditChild: "Muuda last",
        DeleteChild: "Kustuta Laps",
        ChildDetails: "Lapse Andmed",
        ParentClient: "Vanem Klient",
        NoChildren: "Lapsi pole registreeritud",
        ChildrenList: "Laste Nimekiri",
        FirstNameRequired: "Eesnimi on kohustuslik",
        LastNameRequired: "Perekonnanimi on kohustuslik",
        IdentityCodeRequired: "Isikukood on kohustuslik",
        IdentityCodeInvalid: "Vigane Eesti isikukood",
        BirthDateRequired: "Sünniaeg on kohustuslik",
        ChildCreatedSuccessfully: "Laps edukalt lisatud",
        ChildUpdatedSuccessfully: "Lapse andmed edukalt uuendatud",
        ChildDeletedSuccessfully: "Laps edukalt kustutatud",
        FailedToCreateChild: "Lapse lisamine ebaõnnestus",
        FailedToUpdateChild: "Lapse andmete uuendamine ebaõnnestus",
        FailedToDeleteChild: "Lapse kustutamine ebaõnnestus",
        FailedToLoadChildren: "Laste laadimine ebaõnnestus",
        ConfirmDeleteChild: "Kas olete kindel, et soovite selle lapse kustutada?",
        PromoteToAdult: "Muuda Täiskasvanuks",
        PromoteConfirmation: "Kas olete kindel, et soovite selle lapse muuta täiskasvanu kliendiks?",
        PromotedSuccessfully: "Laps edukalt muudetud täiskasvanu kliendiks"
    },
    clientContract: {
        Title: "Lepingud",
        ContractList: "Lepingud",
        ResidueList: "Jäägid",
        Contract: "Leping",
        Contracts: "Lepingud",
        StartDate: "Alguskuupäev",
        EndDate: "Lõppkuupäev",
        YearlyResidue: "Aastane Jääk",
        ContractCode: "Lepingu kood",
        Notes: "Märkused",
        Year: "Aasta",
        TotalResidue: "Kogu Jääk",
        UsedAmount: "Kasutatud Summa",
        UnusedAmount: "Kasutamata Summa",
        CreateContract: "Loo Leping",
        EditContract: "Muuda Lepingut",
        DeleteContract: "Kustuta Leping",
        RecalculateResidues: "Arvuta Jäägid Uuesti",
        StartDateRequired: "Alguskuupäev on kohustuslik",
        EndDateRequired: "Lõppkuupäev on kohustuslik",
        YearlyResidueRequired: "Aastane jääk on kohustuslik",
        ContractPeriod: "Lepingu Kehtivusperiood",
        NoContracts: "Lepinguid ei leitud",
        SelectContractToViewResidues: "Valige leping jääkide vaatamiseks",
        ContractCreatedSuccessfully: "Leping edukalt loodud",
        ContractUpdatedSuccessfully: "Leping edukalt uuendatud",
        ContractDeletedSuccessfully: "Leping edukalt kustutatud",
        FailedToCreateContract: "Lepingu loomine ebaõnnestus",
        FailedToUpdateContract: "Lepingu uuendamine ebaõnnestus",
        FailedToDeleteContract: "Lepingu kustutamine ebaõnnestus",
        FailedToLoadContracts: "Lepingute laadimine ebaõnnestus",
        ConfirmDeleteContract: "Kas olete kindel, et soovite selle lepingu kustutada?"
    },
    suggestion: {
        Suggestions: "Soovitused",
        MySuggestions: "Minu Soovitused",
        ClientSuggestions: "Kliendi Soovitused",
        AddSuggestion: "Lisa Soovitus",
        EditSuggestion: "Muuda Soovitust",
        Suggestion: "Soovitus",
        Title: "Pealkiri",
        Description: "Kirjeldus",
        Date: "Kuupäev",
        Client: "Klient",
        Therapist: "Terapeut",
        DueDate: "Tähtaeg",
        Status: "Olek",
        CompletedDate: "Lõpetatud Kuupäev",
        CreatedDate: "Loodud Kuupäev",
        MarkAsDone: "Märgi Tehtuks",
        MarkAsCompleted: "Märgi lõpetatuks",
        Done: "Tehtud",
        Completed: "Lõpetatud",
        Overdue: "Hilinenud",
        NoSuggestionsFound: "Soovitusi ei leitud",
        ConfirmMarkAsCompleted: "Kas olete kindel, et soovite selle soovituse lõpetatuks märkida?",
        ConfirmDelete: "Kas olete kindel, et soovite kustutada soovituse '{title}'?",
        MarkedAsCompletedSuccess: "Soovitus edukalt lõpetatuks märgitud",
        MarkedAsCompletedError: "Soovituse lõpetatuks märkimine ebaõnnestus",
        LoadError: "Soovituste laadimine ebaõnnestus",
        CreateSuccess: "Soovitus edukalt loodud",
        UpdateSuccess: "Soovitus edukalt uuendatud",
        DeleteSuccess: "Soovitus edukalt kustutatud",
        SaveError: "Soovituse salvestamine ebaõnnestus",
        DeleteError: "Soovituse kustutamine ebaõnnestus",
        TitleRequired: "Pealkiri on kohustuslik",
        EnterTitle: "Sisesta pealkiri",
        EnterDescription: "Sisesta kirjeldus (valikuline)",
        SelectDueDate: "Vali tähtaeg (valikuline)",
        DueDateHint: "Vali täitmise sihtkuupäev",
        SelectStatus: "Vali olek",
        CreateSuggestion: "Loo Soovitus",
        AddFromBookingHint: "Loo sellele kliendile soovitus selle broneeringu sessiooni põhjal"
    },
    notification: {
        ManageNotifications: "Halda teavitusi",
        ManageNotificationsDescription: "Vaata ja halda kõiki süsteemi teavitusi, sh tarneteolek ja uuesti saatmise võimalused",
        NotificationManagement: "Teavituste haldamine",
        NotificationList: "Teavituste nimekiri",
        NotificationId: "ID",
        NotificationDetails: "Teavituse üksikasjad",
        User: "Kasutaja",
        Title: "Pealkiri",
        Message: "Sõnum",
        Type: "Tüüp",
        Status: "Olek",
        Sent: "Saadetud",
        NotSent: "Saatmata",
        Read: "Loetud",
        Abandoned: "Mahajäetud",
        RetryCount: "Uuesti proovimiste arv",
        Booking: "Broneering",
        RelatedBooking: "Seotud broneering",
        CreatedOn: "Loodud",
        SentOn: "Saadetud",
        IsSent: "On saadetud",
        IsRead: "On loetud",
        IsAbandoned: "On mahajäetud",
        IsEmailSent: "E-post saadetud",
        EmailSentOn: "E-post saadetud",
        EmailRetryCount: "E-posti uuesti proovimiste arv",
        EmailSent: "E-post saadetud",
        EmailPending: "E-post ootel",
        FilterByUser: "Filtreeri kasutaja ID järgi",
        FilterBySent: "Filtreeri saatmise järgi",
        FilterByRead: "Filtreeri lugemise järgi",
        FilterByAbandoned: "Filtreeri mahajätmise järgi",
        UserIdPlaceholder: "Sisesta kasutaja ID",
        ResendNotification: "Saada teavitus uuesti",
        ConfirmResend: "Kinnita uuesti saatmine",
        ConfirmResendMessage: "Kas oled kindel, et soovid seda teavitust uuesti saata?",
        Resend: "Saada uuesti",
        ResendSuccess: "Teavitus edukalt uuesti saadetud",
        ResendFailed: "Teavituse uuesti saatmine ebaõnnestus",
        ResendError: "Viga teavituse uuesti saatmisel",
        LoadNotificationsError: "Teavituste laadimine ebaõnnestus",
        NoNotificationsFound: "Teavitusi ei leitud",
        DeliveryStatus: "Tarnestaatus",
        SignalRSentOn: "SignalR saadetud",
        SignalRRetryCount: "SignalR uuesti proovimiste arv",
        ReadOn: "Loetud",
        NotRead: "Lugemata",
    },
    user: {
        UserManagement: "Kasutajate haldamine",
        Users: "Kasutajad",
        User: "Kasutaja",
        Username: "Kasutajanimi",
        Password: "Parool",
        ChangePassword: "Muuda salasõna",
        ChangePasswordMsg: "Teie salasõna on edukalt muudetud.",
        ErrorAtLogging: "Sisse logimise ajal tekkis viga.",
        SuccessfullyLogged: "Edukalt sisse logitud.",
        Role: "Roll",
        CreateUser: "Loo kasutaja",
        EditUser: "Muuda kasutajat",
        DeleteUser: "Kustuta kasutaja",
        SearchByUsernameOrEmail: "Otsi kasutajanime või e-posti järgi",
        FilterByRole: "Filtreeri rolli järgi",
        SelectRole: "Vali roll",
        RoleHelperText: "Vali sellele kasutajale roll",
        UsernameRequired: "Kasutajanimi on kohustuslik",
        PasswordRequired: "Parool on kohustuslik",
        RoleRequired: "Roll on kohustuslik",
        UserSavedSuccessfully: "Kasutaja salvestatud edukalt",
        UserDeletedSuccessfully: "Kasutaja kustutatud edukalt",
        ErrorLoadingUsers: "Viga kasutajate laadimisel",
        ErrorSavingUser: "Viga kasutaja salvestamisel",
        ErrorDeletingUser: "Viga kasutaja kustutamisel",
        CannotDeleteYourself: "Sa ei saa oma kontot kustutada",
        CannotDeleteSystemAdmin: "Süsteemiadministraatori ei saa kustutada",
        ComingSoon: "Kasutajate haldamine tulekohta - API implementatsioon vajalik",
        ResetPassword: "Lähtesta parool",
        ResetPasswordConfirmTitle: "Lähtesta parool?",
        ResetPasswordConfirmMessage: "Kas olete kindel, et soovite lähtestada kasutaja '{0}' parooli? Parooli lähtestamise e-kiri saadetakse nende e-posti aadressile.",
        PasswordResetSuccess: "Parooli lähtestamise e-kiri edukalt saadetud",
        PasswordResetError: "Parooli lähtestamise e-kirja saatmine ebaõnnestus",
        UserDetail: "Kasutaja detail",
        RelatedTo: "Seotud",
        RelatedEntity: "Seotud kirje",
        CanViewAllEntries: "Näeb kõiki kandeid",
        CanViewAllEntriesHelperText: "Kui kasutaja on seotud töötajaga, lubab see tal näha kõigi töötajate kirjeid, mitte ainult enda omi.",
        Employee: "Töötaja",
        Client: "Klient",
        NotLinked: "Sidumata",
        OpenClientDetail: "Ava kliendi detail",
        OpenEmployeeDetail: "Ava töötaja detail",
        UnlinkRelation: "Eemalda seos",
        UnlinkRelationConfirmTitle: "Eemaldada kasutaja seos?",
        UnlinkRelationConfirmMessage: "Kas oled kindel, et soovid eemaldada kasutaja \"{userName}\" seose seotud kliendi/töötaja profiiliga?",
        UnlinkRelationSuccess: "Kasutaja seos eemaldatud",
        UnlinkRelationError: "Kasutaja seose eemaldamine ebaõnnestus"
    },
    role: {
        RoleManagement: "Rollide haldamine",
        Roles: "Rollid",
        Role: "Roll",
        RoleName: "Rolli nimi",
        RoleCode: "Rolli kood",
        Privileges: "Õigused",
        PrivilegeCount: "Õiguste arv",
        CreateRole: "Loo roll",
        EditRole: "Muuda rolli",
        DeleteRole: "Kustuta roll",
        SearchByRoleName: "Otsi rolli nime järgi",
        SelectPrivileges: "Vali õigused",
        RoleNameRequired: "Rolli nimi on kohustuslik",
        RoleCodeRequired: "Rolli kood on kohustuslik",
        RoleSavedSuccessfully: "Roll salvestatud edukalt",
        RoleDeletedSuccessfully: "Roll kustutatud edukalt",
        ErrorLoadingRoles: "Viga rollide laadimisel",
        ErrorSavingRole: "Viga rolli salvestamisel",
        ErrorDeletingRole: "Viga rolli kustutamisel",
        CannotDeleteSystemRole: "Süsteemirolli ei saa kustutada",
        CannotDeleteRoleWithUsers: "Ei saa kustutada rolli, millel on määratud kasutajaid",
        ComingSoon: "Rollide haldamine tulekohta - API implementatsioon vajalik"
    },
    security: {
        ActiveSessions: "Aktiivsed seansid",
        Session: "Seanss",
        NoActiveSessions: "Aktiivseid seansse ei leitud",
        IpAddress: "IP-aadress",
        UserAgent: "Kasutajaagent",
        CreatedOn: "Loodud",
        LastAccessed: "Viimati külastatud",
        ExpiresAt: "Aegub",
        InvalidateSession: "Logi välja",
        ConfirmInvalidateSession: "Kas olete kindel, et soovite sellest seansist välja logida?",
        SessionInvalidated: "Seanss edukalt välja logitud",
        FailedToLoadSessions: "Seansside laadimine ebaõnnestus",
        FailedToInvalidateSession: "Seansist väljalogimine ebaõnnestus",
        LoginAttempts: "Sisselogimiskatsed",
        NoLoginAttempts: "Sisselogimiskatseid ei leitud",
        Successful: "Edukas",
        Failed: "Ebaõnnestunud",
        FailureReason: "Põhjus",
        AttemptedAt: "Proovitud"
    },
    clientInvitation: {
        CompleteRegistration: "Registreerimine lõpule viidud",
        CompleteRegistrationDescription: "Looge oma parool konto seadistamise lõpetamiseks",
        Password: "Parool",
        ConfirmPassword: "Kinnita parool",
        EnterPassword: "Sisestage oma parool",
        EnterConfirmPassword: "Sisestage parool uuesti",
        PasswordHint: "Parool peab olema vähemalt 8 tähemärki",
        PasswordTooShort: "Parool peab olema vähemalt 8 tähemärki",
        PasswordMismatch: "Paroolid ei kattu",
        InvitationExpires: "See kutse aegub",
        InvalidInvitationLink: "Kehtetu kutselink",
        InvitationInvalidOrExpired: "See kutse on kehtetu või aegunud",
        InvitationExpired: "See kutse on aegunud",
        InvitationAlreadyUsed: "Seda kutset on juba kasutatud",
        FailedToLoadInvitation: "Kutse üksikasjade laadimine ebaõnnestus",
        RegistrationCompleteSuccess: "Registreerimine õnnestus! Suuname teid sisselogimislehele...",
        RegistrationFailed: "Registreerimine ebaõnnestus. Palun proovige uuesti.",
        EmailAlreadyRegistered: "See e-posti aadress on juba registreeritud",
        SendInvitation: "Saada kutse",
        InvitationPrompt: "Kliendil ei ole veel kasutajakontot. Saatke kutse, et see luua.",
        ResendInvitation: "Saada kutse uuesti",
        InvitationSent: "Kutse edukalt saadetud",
        InvitationResent: "Kutse edukalt uuesti saadetud",
        FailedToSendInvitation: "Kutse saatmine ebaõnnestus",
        ConfirmSendInvitation: "Kas olete kindel, et soovite sellele kliendile kutse saata?",
        ClientHasNoEmail: "Kliendil pole e-posti aadressi"
    },
    employeeInvitation: {
        SendInvitation: "Saada kutse",
        InvitationPrompt: "Töötajal ei ole veel kasutajakontot. Saatke kutse, et see luua.",
        InvitationSent: "Kutse edukalt saadetud",
        FailedToSendInvitation: "Kutse saatmine ebaõnnestus",
        ConfirmSendInvitation: "Kas saata sellele töötajale registreerimiskutse?",
        EmployeeHasNoEmail: "Töötajal pole e-posti aadressi"
    },
    public: {
        WelcomeToRuumi: "Tere tulemast Akersoni teenused",
        SelectServiceToBook: "Valige teenus teraapiaseansi broneerimiseks",
        SelectServiceCategoryToBook: "Valige teenuse kategooria teraapiaseansi broneerimiseks",
        BookNow: "Broneeri kohe",
        NoServicesAvailable: "Hetkel teenuseid saadaval ei ole",
        SelectDate: "Valige kuupäev",
        SelectTimeSlot: "Valige ajavahemik",
        SelectTime: "Valige aeg",
        SelectParticipant: "Valige osaleja",
        BookingFor: "Broneering kellele",
        SelectParticipantPlaceholder: "Valige lapsevanem või laps",
        SelectParticipantRequired: "Palun valige, kellele broneering tehakse.",
        SelectClientType: "Valige kliendi tüüp",
        SelectedService: "Valitud teenus",
        AvailableFor: "Saadaval",
        Available: "Saadaval",
        YourInformation: "Teie andmed",
        ClientDetails: "Kliendi andmed",
        ProceedToPayment: "Jätka maksega",
        PaymentTermsHeading: "Makse tingimused",
        TermsAgreementLabel: "Nõustun maksetingimustega",
        TermsRequired: "Palun nõustuge maksetingimustega, et jätkata.",
        ViewFullTerms: "Vaata täielikke tingimusi",
        PaymentMethod: "Makseviis",
        SelectPaymentMethod: "Vali makseviis",
        PayWithCard: "Maksa kaardiga",
        UseServicePass: "Kasuta teenusepassi",
        ServicePassAvailable: "Teenusepass saadaval: {name} (alles {remaining} korda)",
        ServicePassUnavailable: "Sellele teenusele pole aktiivset teenusepassi.",
        CheckingServicePass: "Kontrollin teenusepassi...",
        ConfirmWithServicePass: "Kinnita teenusepassiga",
        ConfirmBooking: "Kinnita broneering",
        BookingFailed: "Broneerimine ebaõnnestus. Palun proovige uuesti.",
        ServiceNotAvailable: "Teenus pole selle kombinatsiooni jaoks saadaval. Palun proovige teist valikut.",
        ValidatingPayment: "Makse kontrollimine...",
        PaymentSuccessful: "Makse õnnestus!",
        BookingConfirmed: "Teie broneering on kinnitatud",
        BookingReference: "Broneeringu viide",
        PaymentStatus: "Makse staatus",
        CheckYourEmail: "Kontrollige oma e-posti",
        EmailSentWithDetails: "Saatsime teile kinnituse e-kirja kõigi teie broneeringu üksikasjadega.",
        CreateAccount: "Loo konto",
        BackToHome: "Tagasi avalehele",
        PaymentFailed: "Makse ebaõnnestus",
        PaymentValidationError: "Teie makse kontrollimisel tekkis viga. Palun proovige uuesti või võtke ühendust toega.",
        NoChargeApplied: "Teie kontole ei ole tasu rakendatud.",
        TryBookingAgain: "Proovi uuesti broneerida",
        TryAgain: "Proovi uuesti",
        ContactSupport: "Võta ühendust toega",
        MissingOrderToken: "URL-is puudub tellimuse märgend. Makset ei saa kontrollida.",
        ValidationRequestFailed: "Makse kontrollimise päring ebaõnnestus. Palun kontrollige internetiühendust ja proovige uuesti.",
        PaymentInitiationFailed: "Makse algatamine ebaõnnestus. Palun proovige uuesti.",
        NoTimeSlotsAvailable: "Valitud kuupäevale pole ajavahemikke saadaval. Palun valige teine kuupäev.",
        CheckingAvailability: "Saadavuse kontrollimine...",
        PersonalId: "Isikukood",
        DateOfBirth: "Sünnipäev",
        ClientType: "Kliendi tüüp",
        NoteToTherapist: "Märkus terapeutile (valikuline)",
        PersonalIdPlaceholder: "Sisestage Eesti isikukood",
        DateOfBirthPlaceholder: "Valige oma sünnipäev",
        NotePlaceholder: "Erilised märkused või nõuded..."
    }
};

export default etLocale;

